import { useCallback, useEffect, useRef, useState } from 'react'
import {
  Breadcrumb,
  Button,
  ButtonGroup,
  Card,
  Col,
  Dropdown,
  Form,
  InputGroup,
  ListGroup,
  Modal,
  Row,
  Spinner,
} from 'react-bootstrap'
import { useDisclourse } from '../../hooks/useDisclourse'
import { Tooltip } from 'react-tooltip'
import { AsideMenuPolicies } from './components/AsideMenuPolicies'
import { ModalAddPolice } from './components/ModalAddPolice'
import { useApolloClient, useLazyQuery, useMutation, useQuery } from '@apollo/client'
import { GET_ALL_POLICIES_LIST } from '../../gql/queries/policiesApiQueries'
import { ModalHealthSherpaSearch } from './components/ModalHealthSherpaSearch'
import { toast } from 'react-toastify'
import { IResPoliciesAPI, NodePolicy } from '../../types/policiesApi'
import { hasPermission, parseId } from '../../helpers'
import { Badge } from 'react-bootstrap'
import { ALL_PERMISSIONS } from '../../helpers/consts'
import moment from 'moment'
import { ModalPreview } from './components/ModalPreview'
import { BadgeStatePolicy } from '../onePolicy/components/BadgeStatePolicy'
import { InfoClientPolicy } from './components/InfoClientPolicy'
import {
  METAL_LEVELS,
  SIZE_PAGE_DEFAULT,
  INITIAL_POLICY_FILTERS,
  IMMIGRATION_STATUS_CHOICES,
  DOCUMENT_STATUS_OPTIONS,
  PAYMENT_STATUS_OPTIONS,
  getDocumentVariant,
  getPaymentVariant,
} from '../../helpers/consts'
import { cleanVariables, PaginationUtils } from '../shared/PaginationUtils'

import {
  BLOCK_POLICY,
  CANCEL_POLICY,
  COMPLETE_POLICY,
  EDIT_POLICY,
  MARK_POLICIES_PAID,
  UNPAID_TO_ADVISOR,
  CHARGEBACK_TO_ADVISOR,
  UNCHARGEBACK_TO_ADVISOR,
  SYNC_POLICY_TO_HEALTH_SHERPA,
} from '../../gql/mutations/policyMutation'
import {
  AllPolicyStatusesData,
  IResBlockedPolicyApi,
  IResCancelPolicyApi,
  IResCompletedPolicyApi,
  IResMarkPoliciesPaidApi,
  IResUpdatePolicyApi,
} from '../../types/policies'

import { PaginationSection } from '../shared/PaginationSection'
import { useNavigate } from 'react-router-dom'
import { GET_ALL_POLICIES_STATUSES } from '../../gql/queries/policiesQueries'
import { GET_ALL_SIGNATURE_FORMS_LIST } from '../../gql/queries/signatureFormsApiQueries'
import { GET_ALL_STATES_EU_LIST } from '../../gql/queries/statesEUQuery'
import { GET_ASSIGNMENT_USERS_LIST } from '../../gql/queries/usersQuery'
import { GET_ALL_CARRIERS_LIST } from '../../gql/queries/carriersQuery'
import { GET_ALL_POLICY_TYPE_CATEGORIES } from '../../gql/queries/policyTypesQuery'
import { GET_ALL_LEAD_SOURCES } from '../../gql/queries/leadSourceQuery'
import { GET_MY_POLICY_FILTERS } from '../../gql/queries/policyFiltersQueries'
import { ModalFilters } from './components/ModalFilters'
import { PolicyFilters, PolicySavedFilter } from './policiesTypes'
import { getColorByStatus, getTitleByStatus } from '../shared/utils'
import { ModalQuickUpdates } from './components/ModalQuickUpdates'
import { ModalNotes } from '../onePolicy/components/ModalNotes'
import { ModalAssignAgentPolicy } from '../onePolicy/components/ModalAssignAgentPolicy'
import { ModalViewLogs } from './components/ModalViewLogs'
import { useGetUser } from '../../store/userStore'
import { URL } from '../../gql/client'
import { ModalDuplicatePolicy } from '../onePolicy/components/ModalDuplicatePolicy'
import { AgentInfoTooltip } from '../shared/AgentInfoTooltip'
import { UserAvatar } from '../../components/UserAvatar'
import { AppliedFiltersList } from './components/AppliedFiltersList'
import { IResAllUsers } from '../oneUser/oneUserTypes'
import { GET_ALL_USERS_FILTER } from '../../gql/queries/usersQuery'
import { useStaticCatalog } from '../../hooks/useStaticCatalog'
import { ModalReassignPolicies } from './components/ModalReassignPolicies'
import { ModalUpdatePolicies } from './components/ModalUpdatePolicies'
import { ModalUpdatePoliciesByCarrier } from './components/ModalUpdatePoliciesByCarrier'
import { CarrierImportHistory } from './components/CarrierImportHistory'
import { ModalViewCarrierImportBatch } from './components/ModalViewCarrierImportBatch'
import { ModalCarrierStatusDetails } from './components/ModalCarrierStatusDetails'
import { ModalMemberIdCard } from './components/ModalMemberIdCard'
import {
  CREATE_POLICY_FILTER,
  DELETE_POLICY_FILTER,
  UPDATE_POLICY_FILTER,
} from '../../gql/mutations/policyFilterMutations'
const MEDICARE_ALLOWED_IMMIGRATION_STATUSES = ['CITIZEN', 'RESIDENT']

const isMedicareEligiblePolicy = (nodePolicy: any) => {
  const holder = nodePolicy?.holderMember
  if (!holder || !holder.dateBirth) {
    // console.log('Sync HS Hidden: No holder or DOB', nodePolicy.id)
    return false
  }

  const age = moment().diff(moment(holder.dateBirth), 'years')
  const validStatus = holder.immigrationStatus && MEDICARE_ALLOWED_IMMIGRATION_STATUSES.includes(holder.immigrationStatus.toUpperCase())

  const isEligible = age >= 64 && validStatus
  if (!isEligible) {
    console.log(`Sync HS Hidden for ${holder.firstName}: age=${age}, status=${holder.immigrationStatus}`)
  }

  return isEligible
}



// Hook convertido a lazy loading selectivo - solo carga las queries necesarias
interface LoadFilterOptions {
  loadUsers?: boolean
  loadAgents?: boolean
  loadSignatureForms?: boolean
  loadCarriers?: boolean
  loadStates?: boolean
  loadPolicyTypes?: boolean
  loadLeadSources?: boolean
  unrestrictedAssignmentUsers?: boolean
}

export const useLoadFilterData = (options: LoadFilterOptions) => {
  const client = useApolloClient()

  const fetchUsers = useCallback(
    () =>
      client
        .query({
          query: GET_ASSIGNMENT_USERS_LIST,
          variables: { assignmentCandidates: !options.unrestrictedAssignmentUsers },
          fetchPolicy: 'network-only',
        })
        .then((res) => res.data),
    [client, options.unrestrictedAssignmentUsers]
  )
  const usersCatalog = useStaticCatalog(
    options.unrestrictedAssignmentUsers ? 'all-users-list-unrestricted' : 'all-users-list',
    !!options.loadUsers,
    fetchUsers
  )

  const fetchAgents = useCallback(
    () =>
      client
        .query<IResAllUsers>({
          query: GET_ALL_USERS_FILTER,
          variables: { requireNpn: true },
          fetchPolicy: 'network-only',
        })
        .then((res) => res.data),
    [client]
  )
  const agentsCatalog = useStaticCatalog('agents-with-npn', !!options.loadAgents, fetchAgents)

  const fetchSignatureForms = useCallback(
    () =>
      client
        .query({ query: GET_ALL_SIGNATURE_FORMS_LIST, fetchPolicy: 'network-only' })
        .then((res) => res.data),
    [client]
  )
  const signatureFormsCatalog = useStaticCatalog(
    'signature-forms-active',
    !!options.loadSignatureForms,
    fetchSignatureForms
  )

  const fetchCarriers = useCallback(
    () =>
      client
        .query({ query: GET_ALL_CARRIERS_LIST, fetchPolicy: 'network-only' })
        .then((res) => res.data),
    [client]
  )
  const carriersCatalog = useStaticCatalog('carriers-list', !!options.loadCarriers, fetchCarriers)

  const fetchStates = useCallback(
    () =>
      client
        .query({ query: GET_ALL_STATES_EU_LIST, fetchPolicy: 'network-only' })
        .then((res) => res.data),
    [client]
  )
  const statesCatalog = useStaticCatalog('states-eu', !!options.loadStates, fetchStates)

  const fetchPolicyTypes = useCallback(
    () =>
      client
        .query({ query: GET_ALL_POLICY_TYPE_CATEGORIES, fetchPolicy: 'network-only' })
        .then((res) => res.data),
    [client]
  )
  const policyTypesCatalog = useStaticCatalog(
    'policy-type-categories',
    !!options.loadPolicyTypes,
    fetchPolicyTypes
  )

  const fetchLeadSources = useCallback(
    () =>
      client
        .query({
          query: GET_ALL_LEAD_SOURCES,
          variables: { category: 'Policy', enabled: true },
          fetchPolicy: 'network-only',
        })
        .then((res) => res.data),
    [client]
  )
  const leadSourcesCatalog = useStaticCatalog(
    'lead-sources-policy',
    !!options.loadLeadSources,
    fetchLeadSources
  )

  if (usersCatalog.error) toast.error('Error loading users')
  if (agentsCatalog.error) toast.error('Error loading agents (users with NPN)')
  if (signatureFormsCatalog.error) toast.error('Error loading signature forms')
  if (carriersCatalog.error) toast.error('Error loading carriers')
  if (statesCatalog.error) toast.error('Error loading states')
  if (policyTypesCatalog.error) toast.error('Error loading policy types')
  if (leadSourcesCatalog.error) toast.error('Error loading lead sources')

  return {
    dataUsers: usersCatalog.data,
    dataAgents: agentsCatalog.data,
    dataSignatureForms: signatureFormsCatalog.data,
    dataCarriers: carriersCatalog.data,
    dataStates: statesCatalog.data,
    dataPolicyTypes: policyTypesCatalog.data,
    dataLeadSources: leadSourcesCatalog.data,
    loadingUsers: usersCatalog.loading,
    loadingAgents: agentsCatalog.loading,
    loadingSignatureForms: signatureFormsCatalog.loading,
    loadingCarriers: carriersCatalog.loading,
    loadingStates: statesCatalog.loading,
    loadingPolicyTypes: policyTypesCatalog.loading,
    loadingLeadSources: leadSourcesCatalog.loading,
  }
}

export function useLocalStorage<T>(key: string, initialValue: T) {
  const [storedValue, setStoredValue] = useState<T>(() => {
    try {
      const item = window.localStorage.getItem(key)
      return item ? (JSON.parse(item) as T) : initialValue
    } catch {
      return initialValue
    }
  })

  useEffect(() => {
    try {
      window.localStorage.setItem(key, JSON.stringify(storedValue))
    } catch {
      // puede fallar en modo incógnito
    }
  }, [key, storedValue])

  return [storedValue, setStoredValue] as const
}

export const PoliciesPage = () => {
  const navigate = useNavigate()
  const user = useGetUser((s) => s.user)
  const permissions = useGetUser((s) => s.user?.permissions) || []
  const userGroups = useGetUser((s) => s.user?.groups) || []
  const canMarkAsCompleted =
    permissions && hasPermission(permissions, ALL_PERMISSIONS.MARK_COMPLETED_POLICY)
  const canExportPolicy = permissions && hasPermission(permissions, ALL_PERMISSIONS.EXPORT_POLICY)
  const canReassignPolicies = permissions && hasPermission(permissions, ALL_PERMISSIONS.REASSIGN_POLICY)
  const canBulkUpdatePolicies = permissions && hasPermission(permissions, ALL_PERMISSIONS.BULK_UPDATE_POLICY)
  const canViewAllPolicies =
    permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_ALL_POLICIES)
  const canViewPolicyMemberIdCard =
    permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_POLICY_MEMBER_ID_CARD)
  const canViewCarrierImportHistory =
    (permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_CARRIER_IMPORT_BATCH)) ||
    userGroups.includes('Administrador') ||
    userGroups.includes('SuperAdministrador')
  const canMarkAdvisorPaid =
    userGroups.includes('Supervisor') ||
    userGroups.includes('Administrador') ||
    userGroups.includes('SuperAdministrador')
  const isAgent = userGroups.includes('Agente')
  const apolloClient = useApolloClient()

  const fetchInitialPolicyTypes = useCallback(
    () =>
      apolloClient
        .query({ query: GET_ALL_POLICY_TYPE_CATEGORIES, fetchPolicy: 'network-only' })
        .then((res) => res.data),
    [apolloClient]
  )

  const policyTypesInitCatalog = useStaticCatalog(
    'policy-type-categories',
    true,
    fetchInitialPolicyTypes
  )

  const fetchPolicyStatuses = useCallback(
    () =>
      apolloClient
        .query<AllPolicyStatusesData>({
          query: GET_ALL_POLICIES_STATUSES,
          fetchPolicy: 'network-only',
        })
        .then((res) => res.data),
    [apolloClient]
  )

  const canViewAllPolicyStatuses = hasPermission(permissions, ALL_PERMISSIONS.VIEW_POLICY_STATUS)
  const policyStatusesInitCatalog = useStaticCatalog(
    `policy-statuses:${canViewAllPolicyStatuses ? 'all' : 'agents'}`,
    true,
    fetchPolicyStatuses
  )

  const [gqlGetPolicies, { data: dataAllPolicies, loading, error, refetch }] =
    useLazyQuery<IResPoliciesAPI>(GET_ALL_POLICIES_LIST, {
      fetchPolicy: 'no-cache',
    })

  const { data: dataPolicyFilters, refetch: refetchPolicyFilters } = useQuery<{
    myPolicyFilters: {
      id: string
      name: string
      scope?: string
      filters: string | PolicyFilters
      created?: string
      updated?: string
    }[]
  }>(GET_MY_POLICY_FILTERS, {
    fetchPolicy: 'network-only',
    variables: { scope: 'POLICY' },
  })

  const [gqlCreateP, { data: dataUpdate }] = useMutation<IResUpdatePolicyApi>(EDIT_POLICY)
  const [gglCompleteP, { data: dataCompleted }] = useMutation<IResCompletedPolicyApi>(COMPLETE_POLICY)
  const [gglBlockP, { data: dataBlocked }] = useMutation<IResBlockedPolicyApi>(BLOCK_POLICY)
  const [gglCancelP, { data: dataCancelP }] = useMutation<IResCancelPolicyApi>(CANCEL_POLICY)
  const [gqlMarkPoliciesPaid, { data: dataMarkPoliciesPaid, loading: loadingMarkPoliciesPaid }] =
    useMutation<IResMarkPoliciesPaidApi>(MARK_POLICIES_PAID)
  const [gqlUnpaidToAdvisor, { loading: loadingUnpaid }] = useMutation(UNPAID_TO_ADVISOR)
  const [gqlChargebackToAdvisor, { loading: loadingChargeback }] = useMutation(CHARGEBACK_TO_ADVISOR)
  const [gqlUnchargebackToAdvisor, { loading: loadingUnchargeback }] = useMutation(
    UNCHARGEBACK_TO_ADVISOR
  )
  const [gqlSyncHealthSherpa, { loading: loadingHealthSherpa }] = useMutation(SYNC_POLICY_TO_HEALTH_SHERPA)
  const [gqlCreatePolicyFilter] = useMutation(CREATE_POLICY_FILTER)
  const [gqlUpdatePolicyFilter] = useMutation(UPDATE_POLICY_FILTER)
  const [gqlDeletePolicyFilter] = useMutation(DELETE_POLICY_FILTER)

  const { isOpen: isOpenLogs, onOpen: onOpenLogs, onClose: onCloseLogs } = useDisclourse()
  const { isOpen: isOpenNotes, onOpen: onOpenNotes, onClose: onCloseNotes } = useDisclourse()
  const { isOpen: isOpenFilters, onOpen: onOpenFilters, onClose: onCloseFilters } = useDisclourse()
  const {
    isOpen: isOpenAssignPolicy,
    onOpen: onOpenAssignPolicy,
    onClose: onCloseAssignPolicy,
  } = useDisclourse()
  const {
    isOpen: isOpenQuickUpdate,
    onOpen: onOpenQuickUpdate,
    onClose: onCloseQuickUpdate,
  } = useDisclourse()
  const {
    isOpen: isOpenDuplicate,
    onOpen: onOpenDuplicate,
    onClose: onCloseDuplicate,
  } = useDisclourse()
  const {
    isOpen: isOpenReassignPolicies,
    onOpen: onOpenReassignPolicies,
    onClose: onCloseReassignPolicies,
  } = useDisclourse()
  const {
    isOpen: isOpenUpdatePolicies,
    onOpen: onOpenUpdatePolicies,
    onClose: onCloseUpdatePolicies,
  } = useDisclourse()
  const {
    isOpen: isOpenExportModal,
    onOpen: onOpenExportModal,
    onClose: onCloseExportModal,
  } = useDisclourse()

  const [filtersPolicies, setFiltersPolicies] = useState<
    { id: string; name: string; icon: string }[]
  >([])
  const [exportOptions, setExportOptions] = useState({
    checkPreviousYear: false,
    checkNextYear: false,
  })

  // const [formData, setFormData] = useState<PolicyFilters>({...INITIAL_POLICY_FILTERS})
  const [formData, setFormData] = useLocalStorage<PolicyFilters>(
    'policies-filters',
    INITIAL_POLICY_FILTERS
  )

  const parsePolicyFilterPayload = (rawFilters: string | PolicyFilters | undefined) => {
    if (!rawFilters) return INITIAL_POLICY_FILTERS
    if (typeof rawFilters === 'string') {
      try {
        const parsed = JSON.parse(rawFilters) as PolicyFilters
        return { ...INITIAL_POLICY_FILTERS, ...parsed }
      } catch {
        return INITIAL_POLICY_FILTERS
      }
    }
    return { ...INITIAL_POLICY_FILTERS, ...rawFilters }
  }

  const savedPolicyFilters: PolicySavedFilter[] =
    dataPolicyFilters?.myPolicyFilters?.map((filter) => ({
      id: filter.id,
      name: filter.name,
      created: filter.created,
      updated: filter.updated,
      filters: parsePolicyFilterPayload(filter.filters),
    })) || []

  // Función para determinar qué queries cargar basándose en los filtros aplicados
  const getFilterLoadOptions = (filters: PolicyFilters): LoadFilterOptions => {
    const getLength = (value: unknown) => {
      if (Array.isArray(value)) return value.length
      if (typeof value === 'string') return value.length
      return 0
    }

    return {
      loadUsers: getLength(filters.assignedTo) > 0,
      loadAgents: getLength(filters.user) > 0 || (filters.agentOfRecord?.length ?? 0) > 0,
      loadSignatureForms: !!filters.signatureForm,
      loadCarriers: getLength(filters.carrier) > 0,
      loadStates: getLength(filters.stateEU) > 0,
      loadPolicyTypes: getLength(filters.policyType) > 0,
      loadLeadSources: getLength(filters.leadSource) > 0,
    }
  }

  // Detectar si hay filtros aplicados y determinar qué cargar
  const initialFilterOptions = getFilterLoadOptions(formData)
  const hasAnyFilterToLoad = Object.values(initialFilterOptions).some(v => v === true)

  // Estado para controlar qué datos de filtros cargar
  const [filterLoadOptions, setFilterLoadOptions] = useState<LoadFilterOptions>(
    hasAnyFilterToLoad ? initialFilterOptions : {}
  )

  const dataPolicyTypesInit = policyTypesInitCatalog.data
  if (policyTypesInitCatalog.error) toast.error('Error loading policy types')

  const dataPoliciesStatuses = policyStatusesInitCatalog.data
  if (policyStatusesInitCatalog.error) toast.error('Error loading policy statuses')

  const {
    dataUsers,
    dataAgents,
    dataSignatureForms,
    dataCarriers,
    dataStates,
    dataPolicyTypes,
    dataLeadSources,
    loadingUsers,
    loadingAgents,
    loadingSignatureForms,
    loadingCarriers,
    loadingStates,
    loadingPolicyTypes,
    loadingLeadSources,
  } = useLoadFilterData({
    ...filterLoadOptions,
    unrestrictedAssignmentUsers: canViewAllPolicies,
  })

  const filterData = {
    users:
      dataUsers?.allUsersList?.map((u) => ({
        ...u,
        fullName: `${u.firstName} ${u.lastName}`,
      })) || [],
    agents:
      dataAgents?.allUsers.edges.map(({ node: u }) => ({
        ...u,
        fullName: `${u.firstName} ${u.lastName} - ${u.email} (${u.npn} )`,
      })) || [],
    states: dataStates?.allStatesList || [],
    signatureForms: dataSignatureForms?.allSignatureForms?.edges.map(({ node }) => node) || [],
    carriers: dataCarriers?.allInsuranceOperatorsList || [],
    policyStatuses: dataPoliciesStatuses?.allPolicyStatuses?.edges.map(({ node }) => node) || [],
    immigrationStatuses: IMMIGRATION_STATUS_CHOICES,
    leadSources: dataLeadSources?.allLeadSources?.edges.map(({ node }) => node) || [],
    // Usar dataPolicyTypesInit (siempre cargado) o dataPolicyTypes (lazy loaded)
    policyTypes: (dataPolicyTypesInit || dataPolicyTypes)?.allCategoryPolicy?.edges.map(({ node }) => node) || [],
    documentStatuses: DOCUMENT_STATUS_OPTIONS,
    paymentStatuses: PAYMENT_STATUS_OPTIONS
  }

  /*const [gqlGetCarriers, {data: carrierCategory, error: errorCarriers}] =
    useLazyQuery<AllInsuranceCategoryData>(GET_CARRIER_CATEGORY, {
      fetchPolicy: 'no-cache',
    })*/

  const [showAside, setShowAside] = useState(false)
  const { isOpen, onClose, onOpen } = useDisclourse()
  const { isOpen: isOpenPreview, onClose: onClosePreview, onOpen: onOpenPreview } = useDisclourse()
  const {
    isOpen: isOpenMemberIdCard,
    onClose: onCloseMemberIdCard,
    onOpen: onOpenMemberIdCard,
  } = useDisclourse()
  const {
    isOpen: isOpenCarrierImport,
    onClose: onCloseCarrierImport,
    onOpen: onOpenCarrierImport,
  } = useDisclourse()
  const {
    isOpen: isOpenViewBatch,
    onClose: onCloseViewBatch,
    onOpen: onOpenViewBatch,
  } = useDisclourse()
  const {
    isOpen: isOpenCarrierStatus,
    onClose: onCloseCarrierStatus,
    onOpen: onOpenCarrierStatus,
  } = useDisclourse()

  const [tabFilters, setTabFilters] = useState('Policies')
  const [selectedBatchId, setSelectedBatchId] = useState<string | null>(null)
  const [selectedCarrierStatusPolicyId, setSelectedCarrierStatusPolicyId] = useState<string | null>(null)
  const [importHistoryKey, setImportHistoryKey] = useState(0)

  const [infoPreview, setInfoPreview] = useState<null | NodePolicy>(null)
  const [dataArr, setDataArr] = useState<IResPoliciesAPI['allPolicies']['edges']>([])
  const [first, setFirst] = useState(SIZE_PAGE_DEFAULT)
  const [page, setPage] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)
  const totalItems = dataAllPolicies?.allPolicies?.totalCount ?? 0
  const totalPages = Math.ceil(totalItems / first)
  const { start, end } = PaginationUtils.getPaginationRange(currentPage, first, totalItems)

  const currentYear = new Date().getFullYear()
  const lastThreeYears = [currentYear - 1, currentYear, currentYear + 1]
  const [selectedYears, setSelectedYears] = useLocalStorage<number[]>(
    'policies-selected-years',
    []
  )
  const [searchByMembers, setSearchByMembers] = useState(false)
  const [loadingExports, setLoadingExport] = useState(false)

  // Estado para el ordenamiento
  type SortColumn = 'agent' | 'client' | 'carrier' | 'status' | 'effectiveDate' | 'assignedTo' | null
  type SortDirection = 'asc' | 'desc'
  const [sortColumn, setSortColumn] = useState<SortColumn>(null)
  const [sortDirection, setSortDirection] = useState<SortDirection>('asc')

  const [totalsSnapshot, setTotalsSnapshot] = useState({
    totalPolicies: 0,
    totalApplicantsPolicies: 0,
    totalCanceled: 0,
    totalApplicantsCanceled: 0,
  })
  const [isFetchingTotals, setIsFetchingTotals] = useState(false)

  const prevFiltersRef = useRef({
    first,
    selectedYears: [...selectedYears],
    sortColumn,
    sortDirection,
    tabFilters,
    currentPage,
  })
  const hasInitializedRef = useRef(false)
  const pendingTotalsRequests = useRef(0)
  const skipNextFetchRef = useRef(false)

  // Mapeo de columnas frontend a backend
  const columnToBackendMap: Record<Exclude<SortColumn, null>, string> = {
    agent: 'user',
    client: 'holder',
    carrier: 'carrier',
    status: 'status',
    effectiveDate: 'effectiveDate',
    assignedTo: 'assignedTo',
  }

  interface HandleFiltersOptions {
    page?: number
    includeTotals?: boolean
    suppressAutoFetch?: boolean
  }

  const handleFilters = (override?: PolicyFilters, options?: HandleFiltersOptions) => {
    const data = override ?? formData
    const targetPage = Math.max(1, options?.page ?? currentPage)
    const includeTotals = options?.includeTotals ?? true

    if (options?.suppressAutoFetch) {
      skipNextFetchRef.current = true
    }

    if (includeTotals) {
      pendingTotalsRequests.current += 1
      setIsFetchingTotals(true)
    } else {
      pendingTotalsRequests.current = 0
      setIsFetchingTotals(false)
    }

    const variables = cleanVariables({
      ...data,
      first,
      offset: (targetPage - 1) * first,
      isImportant: tabFilters === 'Important' ? true : null,
      archived: tabFilters === 'Archived' ? true : null,
      hasReminders: tabFilters === 'Reminders' ? true : null,
      hasMemberId: data.hasMemberId,
      commissionPayable: data.commissionPayable,
      commissionPaymentStatus: data.commissionPaymentStatus || null,
      ownsCar: data.ownsCar,
      ownsHome: data.ownsHome,
      hasAutoPolicy: data.hasAutoPolicy,
      hasHomePolicy: data.hasHomePolicy,
      holderName: searchByMembers ? null : data.policyName,
      memberName: searchByMembers ? data.policyName : null,
      effectiveYear: selectedYears.length > 0 ? selectedYears : null,
      insuranceCategory: data.insuranceCategory || null,
      // Transformar signatureForm y agentOfRecord de GraphQL IDs a numéricos solo para la query
      signatureForm: Array.isArray(data.signatureForm) && data.signatureForm.length > 0
        ? data.signatureForm.map((id: string) => parseId(id))
        : null,
      agentOfRecord: Array.isArray(data.agentOfRecord) && data.agentOfRecord.length > 0
        ? data.agentOfRecord.map((id: string) => parseId(id))
        : null,
      acaResult: Array.isArray(data.acaResult) && data.acaResult.length > 0
        ? (data.acaResult as string[]).join(',')
        : data.acaResult && !Array.isArray(data.acaResult)
        ? data.acaResult
        : null,
      acaValidity: data.acaValidity || null,
      orderBy: sortColumn ? columnToBackendMap[sortColumn] : null,
      orderDirection: sortColumn ? sortDirection : null,
      includeTotals,
    })

    const result = gqlGetPolicies({ variables })

    if (includeTotals && result?.finally) {
      result.finally(() => {
        pendingTotalsRequests.current = Math.max(pendingTotalsRequests.current - 1, 0)
        if (pendingTotalsRequests.current === 0) {
          setIsFetchingTotals(false)
        }
      })
    }
  }

  const handlePolicyFilterErrors = (
    errors: { field?: string; message?: string }[] | undefined,
    fallback: string
  ) => {
    const message = errors?.[0]?.message || fallback
    toast.error(message)
  }

  const handleSavePolicyFilter = async (name: string, filters: PolicyFilters) => {
    const trimmedName = name.trim()
    if (!trimmedName) {
      toast.error('Filter name is required.')
      return null
    }

    const result = await gqlCreatePolicyFilter({
      variables: {
        policyFilterData: {
          name: trimmedName,
          scope: 'POLICY',
          filters: JSON.stringify(filters),
        },
      },
    })

    const payload = result.data?.createPolicyFilter
    if (!payload?.success) {
      handlePolicyFilterErrors(payload?.errors, 'Unable to save filter.')
      return null
    }

    await refetchPolicyFilters()
    toast.success('Filter saved.')

    if (!payload.policyFilter) return null
    return {
      id: payload.policyFilter.id,
      name: payload.policyFilter.name,
      filters: parsePolicyFilterPayload(payload.policyFilter.filters),
      updated: payload.policyFilter.updated,
    } as PolicySavedFilter
  }

  const handleUpdatePolicyFilter = async (id: string, name: string, filters: PolicyFilters) => {
    const trimmedName = name.trim()
    if (!trimmedName) {
      toast.error('Filter name is required.')
      return null
    }

    const result = await gqlUpdatePolicyFilter({
      variables: {
        id: parseId(id),
        policyFilterData: {
          name: trimmedName,
          scope: 'POLICY',
          filters: JSON.stringify(filters),
        },
      },
    })

    const payload = result.data?.updatePolicyFilter
    if (!payload?.success) {
      handlePolicyFilterErrors(payload?.errors, 'Unable to update filter.')
      return null
    }

    await refetchPolicyFilters()
    toast.success('Filter updated.')

    if (!payload.policyFilter) return null
    return {
      id: payload.policyFilter.id,
      name: payload.policyFilter.name,
      filters: parsePolicyFilterPayload(payload.policyFilter.filters),
      updated: payload.policyFilter.updated,
    } as PolicySavedFilter
  }

  const handleDeletePolicyFilter = async (id: string) => {
    const result = await gqlDeletePolicyFilter({
      variables: { id: parseId(id) },
    })

    const payload = result.data?.deletePolicyFilter
    if (!payload?.success) {
      handlePolicyFilterErrors(payload?.errors, 'Unable to delete filter.')
      return false
    }

    await refetchPolicyFilters()
    toast.success('Filter deleted.')
    return true
  }

  const handleFilterApply = (filters: any) => {
    const transformedFilters = { ...filters }

    const newFormData = {
      ...formData,
      ...transformedFilters,
    }

    setFormData(newFormData)
    const shouldSuppress = currentPage !== 1
    setCurrentPage(1) // Resetear a la página 1 cuando se aplican filtros
    console.log('New Form Data:', newFormData)

    handleFilters(newFormData, { page: 1, suppressAutoFetch: shouldSuppress })
  }

  const buildPolicyExportParams = (
    formData: PolicyFilters,
    selectedYears: number[],
    tabFilters: string,
    searchByMembers: boolean
  ): URLSearchParams => {
    const toParam = (value: unknown) => {
      if (value == null || value === '') return null
      if (Array.isArray(value)) return value.map(String).join(',')
      return String(value)
    }

    const rawParams: Record<string, string | null | undefined> = {
      isImportant: tabFilters === 'Important' ? 'true' : null,
      archived: tabFilters === 'Archived' ? 'true' : null,
      hasReminders: tabFilters === 'Reminders' ? 'true' : null,
      holderName: searchByMembers ? null : formData.policyName,
      memberName: searchByMembers ? formData.policyName : null,
      effectiveYear: selectedYears.length > 0 ? selectedYears.join(',') : null,
      insuranceCategory: toParam(formData.insuranceCategory),
      carrier: toParam(formData.carrier),
      user: toParam(formData.user),
      assignedTo: toParam(formData.assignedTo),
      signatureForm: Array.isArray(formData.signatureForm) && formData.signatureForm.length > 0
        ? formData.signatureForm.map((id: string) => parseId(id)).join(',')
        : null,
      signatureStatus: formData.signatureStatus || null,
      agentOfRecord: Array.isArray(formData.agentOfRecord) && formData.agentOfRecord.length > 0
        ? formData.agentOfRecord.map((id: string) => parseId(id)).join(',')
        : null,
      stateEU: toParam(formData.stateEU),
      stateJurisdictionType: formData.stateJurisdictionType || null,
      status: toParam(formData.status),
      documentStatus: toParam(formData.documentStatus),
      paymentStatus: toParam(formData.paymentStatus),
      metalLevel: formData.metalLevel || null,
      leadSource: toParam(formData.leadSource),
      policyType: toParam(formData.policyType),
      immigrationStatus: toParam(formData.immigrationStatus),
      holderGender: formData.holderGender || null,
      unassigned: formData.unassigned === true ? 'true' : formData.unassigned === false ? 'false' : null,
      hasMemberId: formData.hasMemberId === true ? 'true' : formData.hasMemberId === false ? 'false' : null,
      commissionPayable: formData.commissionPayable === true ? 'true' : formData.commissionPayable === false ? 'false' : null,
      commissionPaymentStatus: formData.commissionPaymentStatus || null,
      advisorPaid: formData.advisorPaid === true ? 'true' : formData.advisorPaid === false ? 'false' : null,
      advisorChargeback: formData.advisorChargeback === true ? 'true' : formData.advisorChargeback === false ? 'false' : null,
      ownsCar: formData.ownsCar === true ? 'true' : formData.ownsCar === false ? 'false' : null,
      ownsHome: formData.ownsHome === true ? 'true' : formData.ownsHome === false ? 'false' : null,
      hasAutoPolicy: formData.hasAutoPolicy === true ? 'true' : formData.hasAutoPolicy === false ? 'false' : null,
      hasHomePolicy: formData.hasHomePolicy === true ? 'true' : formData.hasHomePolicy === false ? 'false' : null,
      createdAfter: formData.createdAfter,
      createdBefore: formData.createdBefore,
      effectiveDateAfter: formData.effectiveDateAfter,
      effectiveDateBefore: formData.effectiveDateBefore,
      documentsDueDateAfter: formData.documentsDueDateAfter,
      documentsDueDateBefore: formData.documentsDueDateBefore,
      paymentStatusDateAfter: formData.paymentStatusDateAfter,
      paymentStatusDateBefore: formData.paymentStatusDateBefore,
      advisorPaidDateAfter: formData.advisorPaidDateAfter,
      advisorPaidDateBefore: formData.advisorPaidDateBefore,
      advisorChargebackDateAfter: formData.advisorChargebackDateAfter,
      advisorChargebackDateBefore: formData.advisorChargebackDateBefore,
      carrierStatusGeneric: toParam(formData.carrierStatusGeneric),
      carrierStatusRaw: formData.carrierStatusRaw || null,
      carrierLastAsOfDateAfter: formData.carrierLastAsOfDateAfter || null,
      carrierLastAsOfDateBefore: formData.carrierLastAsOfDateBefore || null,
      carrierIsAgeIn:
        formData.carrierIsAgeIn === true ? 'true' : formData.carrierIsAgeIn === false ? 'false' : null,
      carrierIsDelinquent:
        formData.carrierIsDelinquent === true ? 'true' : formData.carrierIsDelinquent === false ? 'false' : null,
      carrierIsUnpaidPending:
        formData.carrierIsUnpaidPending === true
          ? 'true'
          : formData.carrierIsUnpaidPending === false
            ? 'false'
            : null,
      carrierIsUnpaidPastDue:
        formData.carrierIsUnpaidPastDue === true
          ? 'true'
          : formData.carrierIsUnpaidPastDue === false
            ? 'false'
            : null,
      canceledAfter: formData.canceledAfter,
      canceledBefore: formData.canceledBefore,
      acaResult: toParam(formData.acaResult) || null,
      acaValidity: formData.acaValidity || null,
    }

    const params = new URLSearchParams()
    Object.entries(rawParams).forEach(([key, value]) => {
      if (value != null && value !== '') {
        params.append(key, value)
      }
    })

    return params
  }

  const handleDownload = async () => {
    if (!user) return
    const { token } = user
    if (!token) return
    const myHeaders = new Headers()
    myHeaders.append('Authorization', `Bearer ${token}`)

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
    }

    const params = buildPolicyExportParams(formData, selectedYears, tabFilters, searchByMembers)

    // Agregar parámetros de renovación
    if (exportOptions.checkPreviousYear) {
      params.append('checkPreviousYear', 'true')
    }
    if (exportOptions.checkNextYear) {
      params.append('checkNextYear', 'true')
    }

    setLoadingExport(true)

    try {
      const url = `${URL}/export-policies-quick-excel?${params.toString()}`
      console.log('Export URL:', url)
      const res = await fetch(url, requestOptions)
      if (!res.ok) throw new Error('Error al exportar')
      const blob = await res.blob()
      const downloadUrl = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = downloadUrl
      link.download = `policies-${moment().format('DD-MM-YY')}.xlsx`
      document.body.appendChild(link)
      setLoadingExport(false)
      link.click()
      onCloseExportModal()
    } catch (err) {
      setLoadingExport(false)
      toast.error(`ERROR: ${(err as { message: string }).message}`)
    }
  }

  useEffect(() => {
    // Usar dataPolicyTypesInit para el menú lateral (carga inicial)
    const policyTypesData = dataPolicyTypesInit || dataPolicyTypes
    if (policyTypesData?.allCategoryPolicy?.edges) {
      const nuevosFiltros = policyTypesData.allCategoryPolicy.edges.flatMap(({ node }) =>
        (node.policyTypeSet?.edges || []).map(({ node: typeNode }: any) => ({
          id: typeNode.id,
          name: `${node.name} › ${typeNode.typePolicy}`,
          icon: '',
        }))
      )
      setFiltersPolicies(nuevosFiltros)
    }
  }, [dataPolicyTypesInit, dataPolicyTypes])

  const handleSelectPoliciesTab = () => {
    setCurrentPage(1)
    setTabFilters('Policies')
    if (tabFilters !== 'ImportHistory') {
      setFormData(INITIAL_POLICY_FILTERS)
    }
  }

  const handleSelectPolicyTypeTab = (id: string) => {
    setCurrentPage(1)
    setTabFilters(id)
    setFormData((prev) => ({
      ...prev,
      policyType: [parseId(id)],
    }))
  }

  const handleSelectImportantTab = () => {
    setCurrentPage(1)
    setTabFilters('Important')
    setFormData((prev) => ({ ...prev, insuranceCategory: null }))
  }

  const handleSelectRemindersTab = () => {
    setCurrentPage(1)
    setTabFilters('Reminders')
    setFormData((prev) => ({ ...prev, insuranceCategory: null }))
  }

  const handleSelectArchivedTab = () => {
    setCurrentPage(1)
    setTabFilters('Archived')
    setFormData((prev) => ({ ...prev, insuranceCategory: null }))
  }

  const handleSelectImportHistoryTab = () => {
    setCurrentPage(1)
    setTabFilters('ImportHistory')
  }

  /*useEffect(() => {
    if (errorCarriers) toast.error(`Error: ${errorCarriers.message}`)
  }, [errorCarriers])*/

  useEffect(() => {
    setPoliciesSelected([])

    if (skipNextFetchRef.current) {
      skipNextFetchRef.current = false
      prevFiltersRef.current = {
        first,
        selectedYears: [...selectedYears],
        sortColumn,
        sortDirection,
        tabFilters,
        currentPage,
      }
      hasInitializedRef.current = true
      return
    }

    const prev = prevFiltersRef.current
    const selectedYearsChanged =
      prev.selectedYears.length !== selectedYears.length ||
      prev.selectedYears.some((value, index) => value !== selectedYears[index])
    const tabChanged = prev.tabFilters !== tabFilters

    const includeTotals = !hasInitializedRef.current || tabChanged || selectedYearsChanged

    handleFilters(undefined, { includeTotals })

    prevFiltersRef.current = {
      first,
      selectedYears: [...selectedYears],
      sortColumn,
      sortDirection,
      tabFilters,
      currentPage,
    }
    hasInitializedRef.current = true
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [first, currentPage, selectedYears, sortColumn, sortDirection, tabFilters])

  const [policiesSelected, setPoliciesSelected] = useState<
    { id: string; name: string; status: string; user: string; agent: string }[] | undefined
  >([])

  // HealthSherpa Sync State
  const [hsSearchModalOpen, setHsSearchModalOpen] = useState(false)
  const [hsSearchResults, setHsSearchResults] = useState<any[]>([])
  const [hsAgentEmail, setHsAgentEmail] = useState<string>('')
  const [hsSelectedMember, setHsSelectedMember] = useState<any>(null)
  const [hsSearchingMemberId, setHsSearchingMemberId] = useState<string | null>(null)

  const handleSearchBeforeSync = (member: any) => {
    if (!member) return
    setHsSelectedMember(member)
    setHsSearchResults([])
    setHsAgentEmail('')
    setHsSearchModalOpen(true)
    setHsSearchingMemberId(null)
  }

  const [showConfirmPaid, setShowConfirmPaid] = useState(false)
  const [paidAt, setPaidAt] = useState<string>('')
  const [showConfirmUnpaid, setShowConfirmUnpaid] = useState(false)
  const [showConfirmChargeback, setShowConfirmChargeback] = useState(false)
  const [showConfirmUnchargeback, setShowConfirmUnchargeback] = useState(false)
  const [chargebackAt, setChargebackAt] = useState<string>('')

  const isAllSelected = policiesSelected?.length === dataAllPolicies?.allPolicies?.edges?.length

  const fullName = (p?: { firstName?: string | null; lastName?: string | null } | null) =>
    p ? [p.firstName, p.lastName].filter(Boolean).join(' ') : ''

  const toggleAll = () => {
    if (isAllSelected) {
      setPoliciesSelected([])
    } else {
      if (dataAllPolicies?.allPolicies?.edges?.length) {
        const allIds = dataAllPolicies.allPolicies.edges.map((edge) => ({
          id: edge.node.id,
          name: edge.node.policyName,
          status: edge.node.status,
          user: fullName(edge.node.user),
          agent: fullName(edge.node.assignedTo),
        }))
        setPoliciesSelected(allIds)
      }
    }
  }

  const toggleOne = (id: string) => {
    if (!id || !policiesSelected) return

    const exists = policiesSelected.find((x) => x.id === id)

    if (exists) {
      setPoliciesSelected(policiesSelected.filter((x) => x.id !== id))
    } else {
      const found = dataAllPolicies?.allPolicies?.edges.find((e) => e.node?.id === id)

      if (found?.node) {
        setPoliciesSelected([
          ...policiesSelected,
          {
            id: found.node.id,
            name: found.node.policyName,
            status: found.node.status ?? '',
            user: fullName(found.node.user),
            agent: fullName(found.node.assignedTo),
          },
        ])
      }
    }
  }

  const handleMarkPoliciesPaid = (paidAtValue?: string) => {
    if (!policiesSelected || policiesSelected.length === 0) {
      toast.info('Select at least one policy to mark as paid.')
      return
    }

    const paidAtIso = paidAtValue
      ? moment(paidAtValue, 'YYYY-MM-DD').startOf('day').toISOString()
      : undefined

    gqlMarkPoliciesPaid({
      variables: {
        policyIds: policiesSelected.map((policy) => parseId(policy.id)),
        paidAt: paidAtIso,
      },
    })
  }

  const handleUnpaidToAdvisor = () => {
    if (!policiesSelected || policiesSelected.length === 0) {
      toast.info('Select at least one policy to unpaid.')
      return
    }

    gqlUnpaidToAdvisor({
      variables: {
        policyIds: policiesSelected.map((policy) => parseId(policy.id)),
      },
    })
      .then((result) => {
        const data = result.data?.unpaidToAdvisor
        if (!data) return

        const processed = data.processedCount ?? 0
        const skipped = data.skippedCount ?? 0

        if (data.success) {
          if (processed > 0) {
            toast.success(
              `${processed} ${processed === 1 ? 'policy' : 'policies'} marked as unpaid successfully.${skipped > 0 ? ` ${skipped} already unpaid.` : ''}`,
              { autoClose: 10000 }
            )
          } else if (skipped > 0) {
            toast.info(
              `${skipped} ${skipped === 1 ? 'policy was' : 'policies were'} already marked as unpaid.`,
              { autoClose: 10000 }
            )
          }
          refetch()
          setPoliciesSelected([])
        } else {
          // success === false
          if (data.errors && data.errors.length > 0) {
            data.errors.forEach((error: any) => {
              toast.error(error.message)
            })
          } else if (skipped > 0 && processed === 0) {
            // No errors but all skipped - inform user
            toast.info(
              `${skipped} ${skipped === 1 ? 'policy was' : 'policies were'} already marked as unpaid.`,
              { autoClose: 10000 }
            )
            refetch()
            setPoliciesSelected([])
          }
        }
      })
      .catch((error) => {
        toast.error('Error marking policies as unpaid: ' + error.message)
      })
  }

  const handleChargebackToAdvisor = (chargebackAtValue: string) => {
    if (!policiesSelected || policiesSelected.length === 0) {
      toast.info('Select at least one policy to mark as chargeback.')
      return
    }

    if (!chargebackAtValue) {
      toast.error('Please select a chargeback date.')
      return
    }

    const chargebackAtIso = moment(chargebackAtValue, 'YYYY-MM-DD').startOf('day').toISOString()

    gqlChargebackToAdvisor({
      variables: {
        policyIds: policiesSelected.map((policy) => parseId(policy.id)),
        chargebackAt: chargebackAtIso,
      },
    })
      .then((result) => {
        const data = result.data?.chargebackToAdvisor
        if (!data) return

        const processed = data.processedCount ?? 0
        const skipped = data.skippedCount ?? 0

        if (data.success) {
          if (processed > 0) {
            toast.success(
              `${processed} ${processed === 1 ? 'policy' : 'policies'} marked as chargeback successfully.${skipped > 0 ? ` ${skipped} already had chargeback.` : ''}`,
              { autoClose: 10000 }
            )
          } else if (skipped > 0) {
            toast.info(
              `${skipped} ${skipped === 1 ? 'policy was' : 'policies were'} already marked as chargeback.`,
              { autoClose: 10000 }
            )
          }
          refetch()
          setPoliciesSelected([])
        } else {
          // success === false
          if (data.errors && data.errors.length > 0) {
            data.errors.forEach((error: any) => {
              toast.error(error.message)
            })
          } else if (skipped > 0 && processed === 0) {
            // No errors but all skipped - inform user
            toast.info(
              `${skipped} ${skipped === 1 ? 'policy was' : 'policies were'} already marked as chargeback.`,
              { autoClose: 10000 }
            )
            refetch()
            setPoliciesSelected([])
          }
        }
      })
      .catch((error) => {
        toast.error('Error marking policies as chargeback: ' + error.message)
      })
  }

  const handleUnchargebackToAdvisor = () => {
    if (!policiesSelected || policiesSelected.length === 0) {
      toast.info('Select at least one policy to remove chargeback.')
      return
    }

    gqlUnchargebackToAdvisor({
      variables: {
        policyIds: policiesSelected.map((policy) => parseId(policy.id)),
      },
    })
      .then((result) => {
        const data = result.data?.unchargebackToAdvisor
        if (!data) return

        const processed = data.processedCount ?? 0
        const skipped = data.skippedCount ?? 0

        if (data.success) {
          if (processed > 0) {
            toast.success(
              `${processed} ${processed === 1 ? 'policy' : 'policies'} unmarked as chargeback successfully.${skipped > 0 ? ` ${skipped} already had no chargeback.` : ''}`,
              { autoClose: 10000 }
            )
          } else if (skipped > 0) {
            toast.info(
              `${skipped} ${skipped === 1 ? 'policy was' : 'policies were'} already without chargeback.`,
              { autoClose: 10000 }
            )
          }
          refetch()
          setPoliciesSelected([])
        } else {
          if (data.errors && data.errors.length > 0) {
            data.errors.forEach((error: any) => {
              toast.error(error.message)
            })
          } else if (skipped > 0 && processed === 0) {
            toast.info(
              `${skipped} ${skipped === 1 ? 'policy was' : 'policies were'} already without chargeback.`,
              { autoClose: 10000 }
            )
            refetch()
            setPoliciesSelected([])
          }
        }
      })
      .catch((error) => {
        toast.error('Error removing chargeback from policies: ' + error.message)
      })
  }

  const handlePolicyName = () => {
    const shouldSuppress = currentPage !== 1
    setCurrentPage(1) // Resetear a la página 1 cuando se busca
    handleFilters(undefined, { page: 1, suppressAutoFetch: shouldSuppress })
  }

  useEffect(() => {
    if (!dataAllPolicies) return
    const { edges, totalPolicies, totalApplicantsPolicies, totalCanceled, totalApplicantsCanceled } =
      dataAllPolicies.allPolicies
    // El backend maneja el ordenamiento, solo asignamos los datos
    setDataArr(edges)

    if (
      totalPolicies !== null &&
      totalApplicantsPolicies !== null &&
      totalCanceled !== null &&
      totalApplicantsCanceled !== null
    ) {
      setTotalsSnapshot({
        totalPolicies,
        totalApplicantsPolicies,
        totalCanceled,
        totalApplicantsCanceled,
      })
    }
    //gqlGetCarriers({})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataAllPolicies])

  useEffect(() => {
    if (error) {
      pendingTotalsRequests.current = 0
      setIsFetchingTotals(false)
      toast.error(`Error: ${error.message}`)
    }
  }, [error])

  useEffect(() => {
    if (!dataMarkPoliciesPaid) return
    const result = dataMarkPoliciesPaid.markPoliciesAsPaid
    if (result?.success) {
      const processed = result.processedCount ?? 0
      const skipped = result.skippedCount ?? 0
      toast.success(`Policies marked as paid: ${processed}. Skipped: ${skipped}.`, {
        autoClose: 10000,
      })
      setPoliciesSelected([])
      handleFilters(undefined, { includeTotals: false })
      if (result.errors?.length) {
        const msg = result.errors.map((e) => e?.message).filter(Boolean).join('; ')
        if (msg) toast.warn(msg, { autoClose: 10000 })
      }
    } else {
      const processed = result?.processedCount ?? 0
      const skipped = result?.skippedCount ?? 0
      const msg = result?.errors?.map((e) => e?.message).filter(Boolean).join('; ')
      toast.error(
        msg || `No policies marked as paid. Processed: ${processed}. Skipped: ${skipped}.`,
        { autoClose: 10000 }
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataMarkPoliciesPaid])

  const updatePage = (n: number) => {
    setCurrentPage(n)
  }
  const clearFilters = () => {
    const next = { ...INITIAL_POLICY_FILTERS }
    setTabFilters('Policies') // volver a la vista principal
    setFormData(next)
    const shouldSuppress = currentPage !== 1
    setCurrentPage(1) // Resetear a la página 1 cuando se limpian filtros
    handleFilters(next, { page: 1, suppressAutoFetch: shouldSuppress })
  }

  const handleRemoveFilter = (filterKey: string | string[]) => {
    const next = { ...formData }

    // Si es un array de keys (para rangos de fechas), resetear todas
    const keysToReset = Array.isArray(filterKey) ? filterKey : [filterKey]

    keysToReset.forEach((key) => {
      // Resetear el valor del filtro según su tipo
      if (Array.isArray(next[key])) {
        next[key] = []
      } else if (typeof next[key] === 'boolean') {
        next[key] = undefined
      } else {
        next[key] = ''
      }
    })

    setFormData(next)
    const shouldSuppress = currentPage !== 1
    setCurrentPage(1) // Resetear a la página 1 cuando se remueve un filtro
    handleFilters(next, { page: 1, suppressAutoFetch: shouldSuppress })
  }

  const handleUpdatePolicy = async (id: string, data: any) => {
    gqlCreateP({
      variables: {
        id: parseId(id),
        policyData: {
          isImportant: data.isImportant,
          archivedDate: data.archivedDate,
          blockedDate: data.blockedDate,
          status: data.status,
        },
      },
    })
  }

  useEffect(() => {
    if (!dataUpdate) return
    if (dataUpdate.updatePolicy?.success) {
      toast.success('Policy updated successfully')
      handleFilters()
    } else if (dataUpdate.updatePolicy?.errors?.length > 0) {
      toast.error(`Error: ${dataUpdate.updatePolicy.errors[0]?.message || 'Something wrong'}`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataUpdate])

  const comletePolicy = async (id: string) => {
    gglCompleteP({
      variables: {
        id: parseId(id),
      },
    })
  }

  const handleSyncHealthSherpa = async (policyId: string | number) => {
    try {
      const { data } = await gqlSyncHealthSherpa({
        variables: {
          policyId: parseInt(String(parseId(String(policyId))), 10),
        },
      })
      if (data?.syncPolicyToMedicareHealthsherpa?.success) {
        toast.success(data.syncPolicyToMedicareHealthsherpa.message || 'Synced to HealthSherpa successfully')
      } else {
        toast.error(
          data?.syncPolicyToMedicareHealthsherpa?.message || 'Error syncing to HealthSherpa'
        )
      }
    } catch (error) {
      toast.error('Error syncing to HealthSherpa')
    }
  }

  const blockPolicy = async (id: string) => {
    gglBlockP({
      variables: {
        id: parseId(id),
      },
    })
  }

  useEffect(() => {
    if (!dataCompleted) return
    if (dataCompleted.completePolicy?.success) {
      toast.success('Policy updated successfully')
      handleFilters()
    } else if (dataCompleted.completePolicy?.errors?.length > 0) {
      toast.error(`Error: ${dataCompleted.completePolicy.errors[0]?.message || 'Something wrong'}`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataCompleted])

  const cancelPolicy = async (id: string) => {
    gglCancelP({
      variables: {
        id: parseId(id),
      },
    })
  }

  useEffect(() => {
    if (!dataCancelP) return
    if (dataCancelP.cancelPolicy?.success) {
      toast.success('Policy updated successfully')
      handleFilters()
    } else if (dataCancelP.cancelPolicy?.errors?.length > 0) {
      toast.error(`Error: ${dataCancelP.cancelPolicy.errors[0]?.message || 'Something wrong'}`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataCancelP])

  const nonEditableStatuses = ['COMPLETED', 'CANCELED']
  const InfoRow = ({
    label,
    value,
    valueClass = '',
    rowClass = '',
  }: {
    label: string
    value: React.ReactNode
    valueClass?: string
    rowClass?: string
  }) => (
    <div className={`info-row ${rowClass}`}>
      <p className='label'>{label}</p>
      <p className={`value ${valueClass}`}>{value}</p>
    </div>
  )

  // Componente para encabezados ordenables
  const SortableHeader = ({ column, children }: { column: SortColumn; children: React.ReactNode }) => {
    const isActive = sortColumn === column
    const handleSort = () => {
      if (isActive) {
        // Si ya está ordenado por esta columna, invertir la dirección
        setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc')
      } else {
        // Nueva columna, empezar en ascendente
        setSortColumn(column)
        setSortDirection('asc')
      }
    }

    return (
      <th className='fw-bold' style={{ cursor: 'pointer', userSelect: 'none' }} onClick={handleSort}>
        <div className='d-flex align-items-center gap-1'>
          {children}
          <div className='d-flex flex-column' style={{ fontSize: '0.6rem', lineHeight: '0.5' }}>
            <i
              className='bi bi-caret-up-fill'
              style={{
                color: isActive && sortDirection === 'asc' ? '#3e97ff' : '#c4c4c4',
                marginBottom: '-2px',
              }}
            />
            <i
              className='bi bi-caret-down-fill'
              style={{
                color: isActive && sortDirection === 'desc' ? '#3e97ff' : '#c4c4c4',
                marginTop: '-2px',
              }}
            />
          </div>
        </div>
      </th>
    )
  }
  // Remove any local documentVariant or paymentVariant helpers if present

  const carrierOptions = filterData.carriers.map((c) => ({ value: c.id, label: c.name }))
  const userOptions = filterData.users.map((u) => ({ value: u.id, label: u.fullName }))
  const agentsOptions = filterData.agents.map((u) => ({
    value: parseId(u.id),
    label: `${u.firstName} ${u.lastName} - ${u.email}${u.npn ? ` (${u.npn})` : ''}`,
    fullName: `${u.firstName} ${u.lastName}`,
  }))
  const formOptions = filterData.signatureForms.map((f) => ({ value: f.id, label: f.name }))
  const statusOptions = filterData.policyStatuses.map((s) => ({ value: s.code, label: s.title }))
  const leadSourcesOptions = filterData.leadSources.map((s) => ({ value: parseId(s.id), label: s.name }))
  const policyTypesOptions =
    filterData.policyTypes.flatMap((cat: any) =>
      cat.policyTypeSet?.edges?.map(({ node }: any) => ({
        value: parseId(node.id),
        label: `${cat.name} › ${node.typePolicy}`,
      })) || []
    )
  const immigrationOptions = filterData.immigrationStatuses
  const stateOptions = filterData.states.map((s) => ({
    value: s.code,
    label: `${s.name} (${s.code})`,
  }))
  const signatureStatusOptions = [
    { value: 'Signed', label: 'Signed' },
    { value: 'Not Signed', label: 'Not Signed' },
  ]
  const documentStatusOptions = filterData.documentStatuses
  const paymentStatusOptions = filterData.paymentStatuses




  const hasMemberIdOptions = [
    { value: 'true', label: 'With Member ID' },
    { value: 'false', label: 'Without Member ID' },
  ]
  const commissionPayableOptions = [
    { value: 'true', label: 'Considered for commission' },
    { value: 'false', label: 'Not considered for commission' },
  ]
  const commissionPaymentStatusOptions = [
    {value: 'NEVER_STARTED', label: 'Never Started'},
    {value: 'AT_RISK', label: 'At Risk'},
    {value: 'CANCELED', label: 'Canceled'},
  ]
  const advisorPaidOptions = [
    { value: 'true', label: 'Paid' },
    { value: 'false', label: 'Not paid' },
  ]
  const advisorChargebackOptions = [
    { value: 'true', label: 'Chargeback' },
    { value: 'false', label: 'No chargeback' },
  ]
  const yesNoOptions = [
    { value: 'true', label: 'Yes' },
    { value: 'false', label: 'No' },
  ]

  // Helper para formatear fechas - parsea como fecha local para evitar problemas de zona horaria
  const formatDate = (dateStr: string) => {
    if (!dateStr) return ''
    // Parsear como fecha local (no UTC) para evitar que reste/sume días por diferencia horaria
    const [year, month, day] = dateStr.split('-').map(Number)
    const date = new Date(year, month - 1, day) // month es 0-indexed en JS
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })
  }

  const carrierStatusOptions = [
    { value: 'IN_FORCE', label: 'In Force' },
    { value: 'TERMINATED', label: 'Terminated' },
    { value: 'GRACE_PERIOD', label: 'Grace Period' },
    { value: 'PENDING_EFFECTUATION', label: 'Pending Effectuation' },
    { value: 'PAST_DUE', label: 'Past Due' },
    { value: 'DELINQUENT', label: 'Delinquent' },
    { value: 'FUTURE_EFFECTIVE', label: 'Future Effective' },
    { value: 'UNKNOWN', label: 'Unknown' },
  ]

  const filtersConfig = [
    { key: 'carrier', label: 'Carrier', options: carrierOptions },
    { key: 'user', label: 'User', options: agentsOptions },
    { key: 'assignedTo', label: 'Assigned To', options: userOptions },
    { key: 'signatureForm', label: 'Signature Form', options: formOptions },
    { key: 'signatureStatus', label: 'Signature Status', options: signatureStatusOptions },
    { key: 'agentOfRecord', label: 'Agent NPN in Signature Form', options: agentsOptions },
    { key: 'stateEU', label: 'State', options: stateOptions },
    {
      key: 'stateJurisdictionType',
      label: 'State Jurisdiction Type',
      options: [
        { value: 'FEDERAL', label: 'Federal' },
        { value: 'STATE', label: 'State' },
      ],
    },
    { key: 'status', label: 'Policy Status', options: statusOptions },
    { key: 'immigrationStatus', label: 'Immigration Status', options: immigrationOptions },
    { key: 'policyType', label: 'Policy Type', options: policyTypesOptions },
    { key: 'leadSource', label: 'Source', options: leadSourcesOptions },
    { key: 'metalLevel', label: 'Metal Level', options: METAL_LEVELS },
    {
      key: 'documentStatus',
      label: 'Document Status',
      options: documentStatusOptions,
    },
    {
      key: 'paymentStatus',
      label: 'Payment Status',
      options: paymentStatusOptions,
    },
    {
      key: 'hasMemberId',
      label: 'Member ID Status',
      options: hasMemberIdOptions,
      transform: (value: boolean) => value ? 'With Member ID' : 'Without Member ID',
    },
    {
      key: 'commissionPayable',
      label: 'Commission Report',
      options: commissionPayableOptions,
      transform: (value: boolean) => value ? 'Considered for commission' : 'Not considered for commission',
    },
    {
      key: 'commissionPaymentStatus',
      label: 'Commission Payment Status',
      options: commissionPaymentStatusOptions,
    },
    {
      key: 'advisorPaid',
      label: 'Advisor Payment Status',
      options: advisorPaidOptions,
      transform: (value: boolean) => value ? 'Paid' : 'Not paid',
    },
    {
      key: 'advisorChargeback',
      label: 'Advisor Chargeback Status',
      options: advisorChargebackOptions,
      transform: (value: boolean) => value ? 'Chargeback' : 'No chargeback',
    },
    {
      key: 'ownsCar',
      label: 'Owns car',
      options: yesNoOptions,
      transform: (value: boolean) => value ? 'Yes' : 'No',
    },
    {
      key: 'ownsHome',
      label: 'Owns home',
      options: yesNoOptions,
      transform: (value: boolean) => value ? 'Yes' : 'No',
    },
    {
      key: 'hasAutoPolicy',
      label: 'Has auto policy',
      options: yesNoOptions,
      transform: (value: boolean) => value ? 'Yes' : 'No',
    },
    {
      key: 'hasHomePolicy',
      label: 'Has home policy',
      options: yesNoOptions,
      transform: (value: boolean) => value ? 'Yes' : 'No',
    },
    {
      key: 'unassigned',
      label: 'Unassigned',
      options: [
        { value: 'true', label: 'Only unassigned' },
        { value: 'false', label: 'Only assigned' },
      ],
      transform: (value: boolean) => value ? 'Only unassigned' : 'Only assigned',
    },
    {
      key: 'carrierStatusGeneric',
      label: 'Carrier Status',
      options: carrierStatusOptions,
    },
    {
      key: 'carrierIsAgeIn',
      label: 'Age-In',
      options: yesNoOptions,
      transform: (value: boolean) => value ? 'Yes' : 'No',
    },
    {
      key: 'carrierIsDelinquent',
      label: 'Delinquent',
      options: yesNoOptions,
      transform: (value: boolean) => value ? 'Yes' : 'No',
    },
    {
      key: 'carrierIsUnpaidPending',
      label: 'Unpaid Pending',
      options: yesNoOptions,
      transform: (value: boolean) => value ? 'Yes' : 'No',
    },
    {
      key: 'carrierIsUnpaidPastDue',
      label: 'Unpaid Past Due',
      options: yesNoOptions,
      transform: (value: boolean) => value ? 'Yes' : 'No',
    },
    {
      key: 'acaValidity',
      label: 'ACA Validity',
      options: [
        {value: 'active',  label: '≤ 28 days left (any active)'},
        {value: 'days_21', label: '≤ 21 days left'},
        {value: 'days_14', label: '≤ 14 days left'},
        {value: 'days_7',  label: '≤ 7 days left'},
        {value: 'days_3',  label: '≤ 3 days left'},
        {value: 'none',    label: 'No active verification'},
      ],
    },
  ]

  // Filtros de rangos de fechas - se manejan por pares
  const dateRangeFilters = [
    {
      keyFrom: 'effectiveDateAfter',
      keyTo: 'effectiveDateBefore',
      label: 'Effective Date',
    },
    {
      keyFrom: 'createdAfter',
      keyTo: 'createdBefore',
      label: 'Created Date',
    },
    {
      keyFrom: 'documentsDueDateAfter',
      keyTo: 'documentsDueDateBefore',
      label: 'Documents Due Date',
    },
    {
      keyFrom: 'canceledAfter',
      keyTo: 'canceledBefore',
      label: 'Cancellation Date',
    },
    {
      keyFrom: 'paymentStatusDateAfter',
      keyTo: 'paymentStatusDateBefore',
      label: 'Payment Status Date',
    },
    {
      keyFrom: 'advisorPaidDateAfter',
      keyTo: 'advisorPaidDateBefore',
      label: 'Advisor Paid Date',
    },
    {
      keyFrom: 'advisorChargebackDateAfter',
      keyTo: 'advisorChargebackDateBefore',
      label: 'Advisor Chargeback Date',
    },
    {
      keyFrom: 'carrierLastAsOfDateAfter',
      keyTo: 'carrierLastAsOfDateBefore',
      label: 'Carrier As-of Date',
    },
  ]
  return (
    <div className='policies-page'>
      <header className='header'>
        <Breadcrumb>
          <Breadcrumb.Item className='d-blok d-md-none' onClick={() => setShowAside(true)}>
            <span>
              <i className='bi bi-list fs-1' />
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item className='fs-3'>Policies</Breadcrumb.Item>
          {/* <Breadcrumb.Item active>Quote </Breadcrumb.Item> */}
        </Breadcrumb>

        <div className='d-flex align-items-center gap-2'>
          {tabFilters !== 'ImportHistory' && canExportPolicy && (
            <Button
              disabled={loadingExports}
              className='btn-sm btn-outline btn-export'
              onClick={onOpenExportModal}
            >
              {loadingExports ? (
                <>
                  <Spinner animation='border' size='sm' />{' '}
                </>
              ) : (
                <i className='bi bi-download'></i>
              )}
              Export
            </Button>
          )}
          {tabFilters !== 'ImportHistory' && canReassignPolicies && (
            <Button size='sm' onClick={onOpenReassignPolicies}>
              <i className='bi bi-person-up fs-3' /> Reassign
            </Button>
          )}
          {tabFilters !== 'ImportHistory' && canBulkUpdatePolicies && (
            <Button size='sm' variant='secondary' onClick={onOpenUpdatePolicies}>
              <i className='bi bi-pencil-square fs-3' />{' '}
              {(policiesSelected?.length || 0) > 0
                ? `Update (${policiesSelected?.length})`
                : 'Update'}
            </Button>
          )}
          {tabFilters !== 'ImportHistory' && (
            <Button size='sm' onClick={onOpen}>
              <i className='bi bi-plus fs-3' /> New Policy
            </Button>
          )}
          {tabFilters !== 'ImportHistory' && canMarkAdvisorPaid && (policiesSelected?.length || 0) > 0 && (
            <Button
              size='sm'
              variant='success'
              style={{ color: 'black' }}
              onClick={() => {
                setPaidAt(moment().format('YYYY-MM-DD'))
                setShowConfirmPaid(true)
              }}
              disabled={loadingMarkPoliciesPaid}
            >
              {loadingMarkPoliciesPaid
                ? 'Marking...'
                : `Mark as Paid (${policiesSelected?.length || 0})`}
            </Button>
          )}
          {canMarkAdvisorPaid &&
            (policiesSelected?.length || 0) > 0 &&
            policiesSelected?.every(p => {
              const policy = dataAllPolicies?.allPolicies?.edges?.find(e => e.node.id === p.id)
              return policy?.node.advisorPaid === true
            }) && (
              <>
                <Button
                  size='sm'
                  variant='warning'
                  style={{ color: 'black' }}
                  onClick={() => setShowConfirmUnpaid(true)}
                  disabled={loadingUnpaid}
                >
                  {loadingUnpaid ? 'Processing...' : `Unpaid (${policiesSelected?.length || 0})`}
                </Button>
                <Button
                  size='sm'
                  variant='danger'
                  onClick={() => {
                    setChargebackAt(moment().format('YYYY-MM-DD'))
                    setShowConfirmChargeback(true)
                  }}
                  disabled={loadingChargeback}
                >
                  {loadingChargeback ? 'Processing...' : `Chargeback (${policiesSelected?.length || 0})`}
                </Button>
              </>
            )}
          {canMarkAdvisorPaid &&
            (policiesSelected?.length || 0) > 0 &&
            policiesSelected?.every((p) => {
              const policy = dataAllPolicies?.allPolicies?.edges?.find((e) => e.node.id === p.id)
              return policy?.node.advisorChargeback === true
            }) && (
              <Button
                size='sm'
                variant='outline-danger'
                onClick={() => setShowConfirmUnchargeback(true)}
                disabled={loadingUnchargeback}
              >
                {loadingUnchargeback ? 'Processing...' : `Unchargeback (${policiesSelected?.length || 0})`}
              </Button>
            )}
        </div>
      </header>
      <Row className='policies'>
        <Col md={3} lg={3} sm={0} xl={3} className='menu'>
          <div className='menu-aside'>
            <div className='title'>
              <h5 style={{ fontSize: '13px' }}>Menu</h5>
            </div>
            <div className='list-menu'>
              <ListGroup variant='flush'>
                <ListGroup.Item
                  action
                  variant={tabFilters === 'Policies' ? 'primary' : 'light'}
                  onClick={handleSelectPoliciesTab}
                >
                  <i className='bi bi-person-fill fs-3' style={{ color: 'inherit' }} /> Policies
                </ListGroup.Item>

                {filtersPolicies.length > 0 &&
                  filtersPolicies.map((lis) => (
                    <ListGroup.Item
                      key={lis.name}
                      className='filters-favorites'
                      action
                      variant={tabFilters === lis.id ? 'primary' : 'light'}
                      onClick={() => handleSelectPolicyTypeTab(lis.id)}
                    >
                      {lis.icon && (
                        <i
                          className={`bi bi-${lis.icon} fs-3`}
                          style={{ color: 'inherit', marginRight: '8px' }}
                        />
                      )}
                      {lis.name}
                    </ListGroup.Item>
                  ))}

                <ListGroup.Item
                  action
                  variant={tabFilters === 'Important' ? 'primary' : 'light'}
                  onClick={handleSelectImportantTab}
                >
                  <i className='bi bi-star-fill fs-3' style={{ color: 'inherit' }} /> Important
                </ListGroup.Item>
                <ListGroup.Item
                  action
                  variant={tabFilters === 'Reminders' ? 'primary' : 'light'}
                  onClick={handleSelectRemindersTab}
                >
                  <i className='bi bi-clock fs-3' style={{ color: 'inherit' }} /> Reminders
                </ListGroup.Item>
                <ListGroup.Item
                  action
                  variant={tabFilters === 'Archived' ? 'primary' : 'light'}
                  onClick={handleSelectArchivedTab}
                >
                  <i className='bi bi-folder-fill fs-3' style={{ color: 'inherit' }} /> Archived
                </ListGroup.Item>
                {canViewCarrierImportHistory && (
                  <ListGroup.Item
                    action
                    variant={tabFilters === 'ImportHistory' ? 'primary' : 'light'}
                    onClick={handleSelectImportHistoryTab}
                  >
                    <i className='bi bi-cloud-upload fs-3' style={{ color: 'inherit' }} /> Carrier Import History
                  </ListGroup.Item>
                )}
              </ListGroup>
            </div>
          </div>
        </Col>
        <Col md={8} lg={8} sm={12} xl={9} className='container'>
          <div className='policies-container'>
            {tabFilters !== 'ImportHistory' && (
              <>
                <div className='policies-summary d-flex justify-content-between'>
                  <Card className='card-summary green flex-fill mx-2 text-center'>
                    <h3>Policies</h3>
                    <Card.Title>Number of Policies</Card.Title>
                    <Card.Body>
                      {isFetchingTotals && <Spinner animation='border' />}
                      {totalsSnapshot.totalPolicies}
                    </Card.Body>
                  </Card>
                  <Card className='card-summary green flex-fill mx-2 text-center'>
                    <h3>Applicants</h3>
                    <Card.Title>Number of Applicants</Card.Title>
                    <Card.Body>
                      {isFetchingTotals && <Spinner animation='border' />}
                      {totalsSnapshot.totalApplicantsPolicies}
                    </Card.Body>
                  </Card>
                  <Card className='card-summary canceled flex-fill mx-2 text-center'>
                    <h3>Canceled Policies</h3>
                    <Card.Title>Canceled Policies</Card.Title>
                    <Card.Body>
                      {isFetchingTotals && <Spinner animation='border' />}
                      {totalsSnapshot.totalCanceled}
                    </Card.Body>
                  </Card>
                  <Card className='card-summary canceled flex-fill mx-2 text-center'>
                    <h3>Canceled Applicants</h3>
                    <Card.Title>Canceled Applicants</Card.Title>
                    <Card.Body>
                      {isFetchingTotals && <Spinner animation='border' />}
                      {totalsSnapshot.totalApplicantsCanceled}
                    </Card.Body>
                  </Card>
                </div>
                <div className='title-header'>
                  <h3>Policies</h3>
                  <div className='filter-by-years'>
                    {dataArr.length > 0 && <span className='fw-bold me-4'>Effective year:</span>}
                    {lastThreeYears &&
                      lastThreeYears.length > 0 &&
                      lastThreeYears.map((year) => (
                        <Form.Check
                          key={year}
                          inline
                          label={year}
                          checked={selectedYears.includes(year)}
                          onChange={() => {
                            setCurrentPage(1)
                            setSelectedYears(
                              (prev) =>
                                prev.includes(year)
                                  ? prev.filter((y) => y !== year)
                                  : [...prev, year]
                            )
                          }}
                        />
                      ))}
                  </div>
                </div>
                <div className='filters-header'>
                  <div className='line1'>
                    <InputGroup>
                      <Form.Control
                        placeholder='Type your query here...'
                        aria-label="Recipient's username with two button addons"
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            policyName: e.target.value,
                          }))
                        }
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault() // evita el submit automático
                            handlePolicyName() // si tienes una función como esa
                          }
                        }}
                        value={formData.policyName}
                      />
                      <Button
                        onClick={() => {
                          const shouldSuppress = currentPage !== 1
                          setCurrentPage(1) // Resetear a la página 1 cuando se hace clic en Search
                          handleFilters(undefined, { page: 1, suppressAutoFetch: shouldSuppress })
                        }}
                        variant='outline-success'
                        style={{ border: '1px solid #dbdfe9' }}
                      >
                        Search
                      </Button>
                      <Button
                        variant='outline-primary'
                        style={{ border: '1px solid #dbdfe9' }}
                        onClick={() => {
                          // Al abrir el modal, cargar TODAS las opciones de filtros
                          setFilterLoadOptions({
                            loadUsers: true,
                            loadAgents: true,
                            loadSignatureForms: true,
                            loadCarriers: true,
                            loadStates: true,
                            loadPolicyTypes: true,
                            loadLeadSources: true,
                          })
                          onOpenFilters()
                        }}
                      >
                        Filter
                      </Button>
                    </InputGroup>
                  </div>
                  <div className='line2'>
                    <Form.Check
                      type='checkbox'
                      checked={searchByMembers}
                      onChange={(e) => setSearchByMembers(e.target.checked)}
                      label={
                        <span>
                          Search by family members:{' '}
                          <span className='ms-2 ' data-tooltip-id='my-tooltip-info-1'>
                            <i className='bi bi-question-circle-fill text-primary' />
                          </span>
                          <Tooltip
                            id='my-tooltip-info-1'
                            place='bottom'
                            style={{
                              zIndex: 99999,
                              backgroundColor: 'white',
                              color: 'black',
                              boxShadow:
                                'rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px',
                            }}
                          >
                            <div className='tooltip-tfi'>
                              <p style={{ color: '#222' }}>
                                Check this box if you need to search for policies by the name of the
                                members.
                              </p>
                            </div>
                          </Tooltip>
                        </span>
                      }
                    />
                    <AppliedFiltersList
                      filters={formData}
                      config={filtersConfig}
                      dateRangeFilters={dateRangeFilters}
                      formatDate={formatDate}
                      clearFilters={clearFilters}
                      onRemoveFilter={handleRemoveFilter}
                    />
                  </div>
                </div>
              </>
            )}
            {tabFilters === 'ImportHistory' && canViewCarrierImportHistory ? (
              <CarrierImportHistory
                key={importHistoryKey}
                onOpenCarrierImport={onOpenCarrierImport}
                onViewDetails={(batchId) => {
                  setSelectedBatchId(batchId)
                  onOpenViewBatch()
                }}
              />
            ) : (
              <>
                <div className='results-header'>
                  <PaginationSection
                    first={first}
                    setFirst={(n) => {
                      setFirst(n)
                      setPage(1)
                      // setOffset(0)
                    }}
                    currentPage={currentPage}
                    totalPages={totalPages}
                    start={start}
                    end={end}
                    totalPolicies={totalItems}
                    updatePage={updatePage}
                    PaginationUtils={PaginationUtils}
                  />
                  <div className='col-md-3'>
                    <div className='results-filter'>
                      <Col lg={12} md={12} sm={12} xs={12}></Col>
                    </div>
                  </div>
                </div>
                <div className='table-responsive table table-striped table-hover '>
                  <table
                    className='table-scrollable table-scroll  table table-striped table-hover '
                    style={{ whiteSpace: 'nowrap' }}
                  >
                    <thead>
                      <tr role='row'>
                        <th>
                          <input
                            className='form-check-input'
                            type='checkbox'
                            checked={isAllSelected}
                            onChange={toggleAll}
                          />
                        </th>
                        <SortableHeader column='agent'>
                          <span style={{ fontSize: '0.85em', lineHeight: '1.2' }}>
                            Agent<br />Owner
                          </span>
                        </SortableHeader>
                        <SortableHeader column='client'>Client</SortableHeader>
                        <SortableHeader column='carrier'>Policy</SortableHeader>
                        <SortableHeader column='status'>Status</SortableHeader>
                        <SortableHeader column='assignedTo'>Assigned to</SortableHeader>
                        <th className='fw-bold'>Agent of Record</th>
                        {tabFilters === 'Archived' && <th className='fw-bold'>Archived </th>}

                        <th className='fw-bold'>Actions</th>
                      </tr>
                    </thead>
                    {loading || !dataAllPolicies ? (
                      <tbody>
                        <tr>
                          <td colSpan={8}>
                            <div className='d-flex flex-center' style={{ height: '30vh' }}>
                              <Spinner animation='border' />
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    ) : (
                      <tbody>
                        {dataArr.length === 0 && (
                          <tr>
                            <td colSpan={8}>
                              <div className='d-flex flex-center' style={{ height: '30vh' }}>
                                There are no policies currently added
                              </div>
                            </td>
                          </tr>
                        )}
                        {loading && (
                          <tr>
                            <td colSpan={8}>
                              <div className='d-flex flex-center' style={{ height: '30vh' }}>
                                <Spinner animation='border' />
                              </div>
                            </td>
                          </tr>
                        )}
                        {dataArr
                          .slice(first * page - first, first * page)
                          .map(({ node: nodePolicy }, index) => (
                            <tr key={nodePolicy.id + '_' + index}>
                              <td>
                                <div className='set-quick-status'>
                                  <div className='set-important'>
                                    <i
                                      style={{
                                        color: nodePolicy.isImportant ? 'gold' : 'inherit',
                                        cursor: 'pointer',
                                      }}
                                      className='bi bi-star-fill fs-3'
                                      onClick={(e) => {
                                        e.stopPropagation()
                                        nodePolicy.isImportant = !nodePolicy.isImportant
                                        handleUpdatePolicy(nodePolicy.id, {
                                          isImportant: nodePolicy.isImportant,
                                        })
                                      }}
                                    />
                                  </div>
                                  <div>
                                    <input
                                      className='form-check-input'
                                      type='checkbox'
                                      checked={policiesSelected?.some(
                                        (item) => item.id === nodePolicy.id
                                      )}
                                      onClick={(e) => {
                                        e.stopPropagation()
                                      }}
                                      onChange={(e) => {
                                        e.stopPropagation()
                                        toggleOne(nodePolicy?.id)
                                      }}
                                    />
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div>
                                  <UserAvatar
                                    user={nodePolicy.user}
                                    tooltipId={`myt${nodePolicy.id}`}
                                    size={45}
                                  />
                                  <AgentInfoTooltip id={`myt${nodePolicy.id}`} user={nodePolicy.user} />
                                </div>
                              </td>
                              <td>
                                <InfoClientPolicy
                                  id={nodePolicy.id}
                                  holder={nodePolicy.holderMember}
                                  policy={nodePolicy}
                                  isQuote={false}
                                />
                              </td>
                              <td className='limit-width'>
                                <div className='info-policy-name'>
                                  <span
                                    className='text-primary text-link fw-bold'
                                    style={{ cursor: 'pointer' }}
                                    data-tooltip-id={`myt2${parseId(nodePolicy.id)}`}
                                  >
                                    {nodePolicy.carrier?.name || 'N/R'}
                                  </span>
                                  <p className='m-0 p-0' style={{ fontSize: '0.95rem' }}>
                                    Effective: {moment(nodePolicy.effectiveDate).format('MMM DD, YYYY')}
                                  </p>
                                  <div className='d-flex align-items-center gap-2 mt-1'>
                                    <Badge
                                      bg='primary'
                                      className='d-flex align-items-center gap-1 text-white'
                                      title={`${nodePolicy.applicants || 0} Applicant${(nodePolicy.applicants || 0) !== 1 ? 's' : ''}`}
                                    >
                                      <i className='bi bi-people-fill' />
                                      {nodePolicy.applicants || 0}
                                    </Badge>
                                    {nodePolicy.memberId && (
                                      <span className='m-0 p-0' style={{ fontSize: '0.95rem' }}>
                                        ID: {nodePolicy.memberId}
                                      </span>
                                    )}
                                    {nodePolicy.hasAutoPolicy === true ? (
                                      <Badge
                                        bg='success'
                                        className='d-flex align-items-center text-white'
                                        title='Has auto policy'
                                      >
                                        <i className='bi bi-car-front-fill' style={{ color: 'var(--bs-white)' }} />
                                      </Badge>
                                    ) : nodePolicy.ownsCar === true ? (
                                      <Badge
                                        bg='danger'
                                        className='d-flex align-items-center text-white'
                                        title='Owns car'
                                      >
                                        <i className='bi bi-car-front-fill' style={{ color: 'var(--bs-white)' }} />
                                      </Badge>
                                    ) : null}
                                    {nodePolicy.hasHomePolicy === true ? (
                                      <Badge
                                        bg='success'
                                        className='d-flex align-items-center text-white'
                                        title='Has home policy'
                                      >
                                        <i className='bi bi-house-fill' style={{ color: 'var(--bs-white)' }} />
                                      </Badge>
                                    ) : nodePolicy.ownsHome === true ? (
                                      <Badge
                                        bg='danger'
                                        className='d-flex align-items-center text-white'
                                        title='Owns home'
                                      >
                                        <i className='bi bi-house-fill' style={{ color: 'var(--bs-white)' }} />
                                      </Badge>
                                    ) : null}
                                    {/* {isMedicareEligiblePolicy(nodePolicy) && (
                                  <div className="d-flex align-items-center gap-2">
                                    {nodePolicy.holderMember?.healthsherpaContactId ? (
                                      <Badge bg="success" className="text-white" title="Synced to HealthSherpa">
                                        <i className="fa fa-check-circle mr-1"></i>
                                        HS Synced
                                      </Badge>
                                    ) : (
                                      <Button
                                        variant="outline-info"
                                        size="sm"
                                        className="sync-hs-button btn-xs py-0 px-2"
                                        onClick={() => handleSearchBeforeSync(nodePolicy.holderMember)}
                                        disabled={hsSearchingMemberId === nodePolicy.holderMember?.id}
                                      >
                                        {hsSearchingMemberId === nodePolicy.holderMember?.id ? (
                                          <Spinner animation="border" size="sm" />
                                        ) : (
                                          <>
                                            <i className="fa fa-sync-alt mr-1"></i>
                                            Sync HS
                                          </>
                                        )}
                                      </Button>
                                    )}
                                  </div>
                                )} */}
                                  </div>
                                  <Tooltip
                                    clickable={true}
                                    delayHide={500}
                                    id={`myt2${parseId(nodePolicy.id)}`}
                                    place='top'
                                    className='tooltip-tfi tooltip-clean'
                                  >
                                    <div className='tooltip-content'>
                                      <h6 className='text-center'>More information:</h6>

                                      <InfoRow label='Product:' value='Policy' />
                                      <InfoRow label='Plan:' value='' />
                                      <InfoRow label='' value={nodePolicy.planName || 'N/R'} />
                                      <InfoRow
                                        label='Metal:'
                                        value={
                                          METAL_LEVELS.find(
                                            (m) => m.value === String(nodePolicy.metalLevel)
                                          )?.label || 'N/A'
                                        }
                                      />
                                      <InfoRow label='Premium:' value={`$${nodePolicy.premium}`} />
                                      <InfoRow label='NPN:' value={nodePolicy.NPN || 'N/A'} />
                                      <InfoRow
                                        label='Blocked:'
                                        value={nodePolicy.blockedDate ? '✅ Yes' : '❌ No'}
                                        valueClass={
                                          nodePolicy.blockedDate ? 'text-success' : 'text-danger'
                                        }
                                      />
                                      <InfoRow
                                        label='Is duplicate?'
                                        value={nodePolicy.isDuplicated ? '✅ Yes' : '❌ No'}
                                        valueClass={
                                          nodePolicy.isDuplicated ? 'text-success' : 'text-danger'
                                        }
                                      />
                                      <InfoRow
                                        label='Submitted:'
                                        value={moment(nodePolicy.created).format('DD MMM, YY HH:mm')}
                                      />
                                      <InfoRow
                                        label='Last update:'
                                        value={moment(nodePolicy.updated).format('DD MMM, YY HH:mm')}
                                      />
                                    </div>
                                  </Tooltip>
                                </div>
                              </td>

                              <td>
                                <div>
                                  <BadgeStatePolicy
                                    status={getTitleByStatus(
                                      dataPoliciesStatuses?.allPolicyStatuses.edges ?? [],
                                      nodePolicy.status
                                    )}
                                    color={getColorByStatus(
                                      dataPoliciesStatuses?.allPolicyStatuses.edges ?? [],
                                      nodePolicy.status
                                    )}
                                  />
                                  <span className='d-block'>
                                    Documents:{' '}
                                    <Badge
                                      className='badge-sm'
                                      bg={getDocumentVariant(nodePolicy.stateDocs)}
                                    >
                                      {nodePolicy.stateDocs || 'N/A'}
                                    </Badge>
                                  </span>
                                  {nodePolicy.documentsDueDate && (
                                    <span className='d-block'>
                                      Docs Due Date:{' '}
                                      <Badge
                                        className='badge-sm'
                                        bg={
                                          moment(nodePolicy.documentsDueDate).startOf('day').isBefore(moment().startOf('day'))
                                            ? 'danger'
                                            : 'warning'
                                        }
                                        text={
                                          moment(nodePolicy.documentsDueDate).startOf('day').isBefore(moment().startOf('day'))
                                            ? 'white'
                                            : 'dark'
                                        }
                                      >
                                        {moment(nodePolicy.documentsDueDate).format('MMM DD, YYYY')}
                                      </Badge>
                                    </span>
                                  )}
                                  <span>
                                    Payment:{' '}
                                    <Badge
                                      className='badge-sm'
                                      bg={getPaymentVariant(nodePolicy.paymentStatus)}
                                      text={getPaymentVariant(nodePolicy.paymentStatus) === 'danger' ? 'white' : undefined}
                                    >
                                      {nodePolicy.paymentStatus || 'N/A'}
                                    </Badge>
                                  </span>
                                  {nodePolicy.carrierStatusGeneric && (
                                    <span className='d-block'>
                                      Carrier:{' '}
                                      <Badge
                                        className='badge-sm'
                                        bg={
                                          nodePolicy.carrierStatusGeneric === 'IN_FORCE' ? 'success'
                                            : nodePolicy.carrierStatusGeneric === 'TERMINATED' ? 'danger'
                                              : nodePolicy.carrierStatusGeneric === 'DELINQUENT' ? 'warning'
                                                : nodePolicy.carrierStatusGeneric === 'PAST_DUE' ? 'warning'
                                                  : nodePolicy.carrierStatusGeneric === 'GRACE_PERIOD' ? 'warning'
                                                    : nodePolicy.carrierStatusGeneric === 'PENDING_EFFECTUATION' ? 'info'
                                                      : 'secondary'
                                        }
                                        text={
                                          ['DELINQUENT', 'PAST_DUE', 'GRACE_PERIOD', 'WARNING'].includes(nodePolicy.carrierStatusGeneric)
                                            ? 'dark'
                                            : nodePolicy.carrierStatusGeneric === 'PENDING_EFFECTUATION'
                                              ? 'white'
                                              : undefined
                                        }
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                          setSelectedCarrierStatusPolicyId(String(parseId(nodePolicy.id)))
                                          onOpenCarrierStatus()
                                        }}
                                      >
                                        {nodePolicy.carrierStatusGeneric === 'IN_FORCE' &&
                                          nodePolicy.carrierStatusRaw
                                          ? `${nodePolicy.carrierStatusRaw} (IN_FORCE)`
                                          : (nodePolicy.carrierStatusRaw || nodePolicy.carrierStatusGeneric)}
                                      </Badge>
                                      {nodePolicy.carrierIsAgeIn && (
                                        <Badge className='badge-sm ms-1' bg='info' text='white'>AGE-IN</Badge>
                                      )}
                                      {nodePolicy.carrierIsDelinquent && nodePolicy.carrierStatusGeneric !== 'DELINQUENT' && (
                                        <Badge className='badge-sm ms-1' bg='warning' text='dark'>DLQ</Badge>
                                      )}
                                      {nodePolicy.carrierLastAsOfDate && (
                                        <small className='d-block ms-5 mt-1'>
                                          <span>As of:</span>{' '}
                                          <span style={{color: '#000'}}>
                                            {moment(nodePolicy.carrierLastAsOfDate).format('MMM DD, YYYY')}
                                          </span>
                                        </small>
                                      )}
                                    </span>
                                  )}
                                </div>
                              </td>
                              <td>
                                <div style={{
                                  maxWidth: '150px',
                                  minWidth: '120px',
                                  wordBreak: 'break-word',
                                  whiteSpace: 'normal',
                                  lineHeight: '1.3'
                                }}>
                                  {nodePolicy.assignedTo?.firstName} {nodePolicy.assignedTo?.lastName}
                                  {nodePolicy.advisorPaid && (
                                    <div className='mt-1'>
                                      <Badge bg='success' className='badge-sm'>
                                        PAID TO ADVISOR
                                      </Badge>
                                      {nodePolicy.advisorPaidAt && (
                                        <div style={{ fontSize: '0.85rem' }}>
                                          {moment(nodePolicy.advisorPaidAt).format('MMM DD, YYYY')}
                                        </div>
                                      )}
                                    </div>
                                  )}
                                  {nodePolicy.advisorChargeback && (
                                    <div className='mt-1'>
                                      <Badge bg='danger' className='badge-sm' style={{ color: 'white' }}>
                                        CHARGEBACK
                                      </Badge>
                                      {nodePolicy.advisorChargebackAt && (
                                        <div style={{ fontSize: '0.85rem' }}>
                                          {moment(nodePolicy.advisorChargebackAt).format('MMM DD, YYYY')}
                                        </div>
                                      )}
                                    </div>
                                  )}
                                  {(() => {
                                    const aca = nodePolicy.latestAcaVerification
                                    if (!aca?.result || !aca?.created) return null
                                    const daysElapsed = (Date.now() - new Date(aca.created).getTime()) / 86400000
                                    if (daysElapsed > 28) return null
                                    const daysLeft = Math.ceil(28 - daysElapsed)
                                    const ACA_RESULT_CONFIG: Record<string, {label: string; bg: string; textClass: string}> = {
                                      green:  {label: 'Paid & Completed',       bg: '#198754', textClass: 'text-white'},
                                      yellow: {label: 'Paid / Pending Docs',    bg: '#ffc107', textClass: 'text-dark'},
                                      red:    {label: 'Unpaid / Pending',       bg: '#dc3545', textClass: 'text-white'},
                                      blue:   {label: '$0 Premium / Completed', bg: '#0d6efd', textClass: 'text-white'},
                                    }
                                    const cfg = ACA_RESULT_CONFIG[aca.result.toLowerCase()]
                                    if (!cfg) return null
                                    return (
                                      <div className='mt-1'>
                                        <span
                                          className={`badge badge-sm ${cfg.textClass}`}
                                          style={{backgroundColor: cfg.bg}}
                                        >
                                          ACA: {cfg.label}
                                        </span>
                                        <div
                                          style={{
                                            fontSize: '0.78rem',
                                            color: daysLeft <= 5 ? '#dc3545' : '#6c757d',
                                            fontWeight: daysLeft <= 5 ? 600 : 400,
                                          }}
                                        >
                                          {daysLeft} {daysLeft === 1 ? 'day' : 'days'} left
                                        </div>
                                      </div>
                                    )
                                  })()}
                                </div>
                              </td>
                              <td>
                                <div style={{
                                  maxWidth: '150px',
                                  minWidth: '120px',
                                  wordBreak: 'break-word',
                                  whiteSpace: 'normal',
                                  lineHeight: '1.3'
                                }}>
                                  {nodePolicy.agentOfRecord || ''}
                                </div>
                              </td>
                              {tabFilters === 'Archived' && (
                                <td>{moment(nodePolicy.archivedDate).format('DD MMM, YY')}</td>
                              )}

                              <td>
                                <Dropdown as={ButtonGroup}>
                                  <Button
                                    variant='outline-primary'
                                    size='sm'
                                    style={{border: '1px solid #3e97ff'}}
                                    onClick={() => {
                                      onOpenPreview()
                                      setInfoPreview(nodePolicy)
                                    }}
                                  >
                                    Preview
                                  </Button>
                                  <Dropdown.Toggle
                                    split
                                    variant='outline-primary'
                                    size='sm'
                                    id='dropdown-custom-2'
                                    style={{border: '1px solid #3e97ff'}}
                                  />
                                  <Dropdown.Menu className='dropdown-menu-policy'>
                                    {canViewPolicyMemberIdCard && (
                                      <>
                                        <Dropdown.Item
                                          onClick={() => {
                                            onOpenMemberIdCard()
                                            setInfoPreview(nodePolicy)
                                          }}
                                        >
                                          <i className='bi bi-credit-card-2-front' /> Get member ID card
                                        </Dropdown.Item>
                                        <Dropdown.Divider />
                                      </>
                                    )}
                                    {isMedicareEligiblePolicy(nodePolicy) && (
                                      <>
                                        <Dropdown.Item
                                          onClick={(e) => {
                                            e.stopPropagation()
                                            handleSyncHealthSherpa(nodePolicy.id)
                                          }}
                                          disabled={loadingHealthSherpa}
                                        >
                                          {loadingHealthSherpa ? (
                                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className='me-2' />
                                          ) : (
                                            <i className='bi bi-cloud-arrow-up text-primary' />
                                          )}{' '}
                                          Sync to HealthSherpa
                                        </Dropdown.Item>
                                        <Dropdown.Divider />
                                      </>
                                    )}
                                    {!nonEditableStatuses.includes(nodePolicy.status) &&
                                      canMarkAsCompleted && (
                                        <Dropdown.Item
                                          onClick={(e) => {
                                            e.stopPropagation()
                                            comletePolicy(nodePolicy.id)
                                          }}
                                        >
                                          <i
                                            className='bi bi-check-circle-fill fs-2'
                                            style={{ color: 'green' }}
                                          />
                                          Mark as completed
                                        </Dropdown.Item>
                                      )}
                                    <Dropdown.Divider />
                                    {nodePolicy.blockedDate === null ? (
                                      <Dropdown.Item
                                        onClick={(e) => {
                                          e.stopPropagation()
                                          const blockedDateStr = new Date().toISOString()
                                          nodePolicy.blockedDate = blockedDateStr
                                          handleUpdatePolicy(nodePolicy.id, {
                                            blockedDate: blockedDateStr,
                                          })
                                        }}
                                      >
                                        <i className='bi bi-folder-fill' /> Mark as blocked
                                      </Dropdown.Item>
                                    ) : (
                                      <Dropdown.Item
                                        onClick={(e) => {
                                          e.stopPropagation()
                                          nodePolicy.blockedDate = ''
                                          handleUpdatePolicy(nodePolicy.id, {
                                            blockedDate: null,
                                          })
                                        }}
                                      >
                                        <i className='bi bi-folder-fill' /> Mark as unblocked
                                      </Dropdown.Item>
                                    )}
                                    <Dropdown.Item
                                      onClick={() => navigate(`/one-policy/${parseId(nodePolicy.id)}`)}
                                    >
                                      <i className='bi bi-pencil-fill' /> Edit
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      onClick={() => {
                                        onOpenDuplicate()
                                        setInfoPreview(nodePolicy)
                                      }}
                                    >
                                      <i className='bi bi-collection-fill' /> Duplicate
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      onClick={() => {
                                        onOpenQuickUpdate()
                                        setInfoPreview(nodePolicy)
                                      }}
                                    >
                                      <i className='bi bi-arrow-repeat' /> Quick update
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      onClick={() => {
                                        onOpenAssignPolicy()
                                        setInfoPreview(nodePolicy)
                                      }}
                                    >
                                      <i className='bi bi-person-check' /> Assign policy
                                    </Dropdown.Item>
                                    <Dropdown.Item eventKey='6'>
                                      <i className='bi bi-arrow-repeat' /> Add reminder
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      onClick={() => {
                                        setInfoPreview(nodePolicy)
                                        onOpenNotes()
                                      }}
                                    >
                                      <i className='bi bi-pencil-square' /> Add Note
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      onClick={() => {
                                        setInfoPreview(nodePolicy)
                                        onOpenLogs()
                                      }}
                                    >
                                      <i className='bi bi-list-columns-reverse' /> View Logs
                                    </Dropdown.Item>
                                    {!nonEditableStatuses.includes(nodePolicy.status) &&
                                      nodePolicy.archivedDate === null && (
                                        <>
                                          <Dropdown.Divider />
                                          <Dropdown.Item
                                            onClick={(e) => {
                                              e.stopPropagation()
                                              const archivedDateStr = new Date().toISOString()
                                              nodePolicy.archivedDate = archivedDateStr
                                              handleUpdatePolicy(nodePolicy.id, {
                                                archivedDate: archivedDateStr,
                                              })
                                            }}
                                          >
                                            <i className='bi bi-folder-fill' /> Mark as archived
                                          </Dropdown.Item>
                                        </>
                                      )}
                                    {!nonEditableStatuses.includes(nodePolicy.status) &&
                                      nodePolicy.archivedDate !== null && (
                                        <>
                                          <Dropdown.Divider />
                                          <Dropdown.Item
                                            onClick={(e) => {
                                              e.stopPropagation()
                                              nodePolicy.archivedDate = ''
                                              handleUpdatePolicy(nodePolicy.id, {
                                                archivedDate: null,
                                              })
                                            }}
                                          >
                                            <i className='bi bi-folder-fill' /> Mark as unarchived
                                          </Dropdown.Item>
                                        </>
                                      )}
                                    {!nonEditableStatuses.includes(nodePolicy.status) && (
                                      <>
                                        <Dropdown.Item
                                          onClick={(e) => {
                                            e.stopPropagation()
                                            cancelPolicy(nodePolicy.id)
                                          }}
                                        >
                                          <i
                                            className='bi bi-x-circle-fill fs-2'
                                            style={{ color: 'red' }}
                                          />
                                          Mark as Cancel
                                        </Dropdown.Item>
                                      </>
                                    )}
                                  </Dropdown.Menu>
                                </Dropdown>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    )}
                  </table>
                </div>
              </>
            )}
          </div>
        </Col>
      </Row>

      {showAside && (
        <AsideMenuPolicies
          isOpen={showAside}
          onClose={() => setShowAside(false)}
          tabFilters={tabFilters}
          filtersPolicies={filtersPolicies}
          canViewCarrierImportHistory={canViewCarrierImportHistory}
          onSelectPolicies={handleSelectPoliciesTab}
          onSelectPolicyType={handleSelectPolicyTypeTab}
          onSelectImportant={handleSelectImportantTab}
          onSelectReminders={handleSelectRemindersTab}
          onSelectArchived={handleSelectArchivedTab}
          onSelectImportHistory={handleSelectImportHistoryTab}
        />
      )}

      {isOpen && (
        <ModalAddPolice
          refetch={refetch}
          isOpen={isOpen}
          onClose={onClose}
          keyboard={false}
          backdrop='static'
        />
      )}
      {isOpenPreview && infoPreview && (
        <ModalPreview
          id={infoPreview.id}
          isOpen={isOpenPreview}
          onClose={onClosePreview}
          statusColor={getColorByStatus(
            dataPoliciesStatuses?.allPolicyStatuses.edges ?? [],
            infoPreview.status
          )}
        />
      )}
      {isOpenMemberIdCard && infoPreview && (
        <ModalMemberIdCard id={infoPreview.id} isOpen={isOpenMemberIdCard} onClose={onCloseMemberIdCard} />
      )}
      {isOpenFilters && (
        <ModalFilters
          isOpen={isOpenFilters}
          onClose={onCloseFilters}
          onApply={handleFilterApply}
          savedFilters={savedPolicyFilters}
          onSaveFilter={handleSavePolicyFilter}
          onUpdateFilter={handleUpdatePolicyFilter}
          onDeleteFilter={handleDeletePolicyFilter}
          setFilters={setFormData}
          filters={formData}
          users={filterData.users}
          agents={filterData.agents}
          states={filterData.states}
          immigrationStatuses={filterData.immigrationStatuses}
          signatureForms={filterData.signatureForms}
          carriers={filterData.carriers}
          policyStatuses={filterData.policyStatuses}
          documentStatuses={filterData.documentStatuses}
          paymentStatuses={filterData.paymentStatuses}
          policyTypes={filterData.policyTypes}
          leadSources={filterData.leadSources}
          isLoading={
            (filterLoadOptions.loadUsers && loadingUsers) ||
            (filterLoadOptions.loadAgents && loadingAgents) ||
            (filterLoadOptions.loadCarriers && loadingCarriers) ||
            (filterLoadOptions.loadStates && loadingStates) ||
            (filterLoadOptions.loadSignatureForms && loadingSignatureForms) ||
            (filterLoadOptions.loadPolicyTypes && loadingPolicyTypes) ||
            (filterLoadOptions.loadLeadSources && loadingLeadSources)
          }
          isAgent={isAgent}
        />
      )}
      {isOpenCarrierImport && (
        <ModalUpdatePoliciesByCarrier
          isOpen={isOpenCarrierImport}
          onClose={onCloseCarrierImport}
          onSuccess={() => {
            refetch?.()
            setImportHistoryKey(prev => prev + 1) // Force refresh Import History
          }}
          carriers={filterData.carriers}
          policyStatuses={filterData.policyStatuses}
        />
      )}
      {infoPreview && isOpenQuickUpdate && (
        <ModalQuickUpdates
          node={infoPreview}
          isOpen={isOpenQuickUpdate}
          onClose={onCloseQuickUpdate}
          refetch={refetch}
        />
      )}
      {infoPreview && isOpenAssignPolicy && (
        <ModalAssignAgentPolicy
          id={infoPreview.id}
          isOpen={isOpenAssignPolicy}
          onClose={onCloseAssignPolicy}
          refetch={refetch}
          typeAssign={'ASSIGN_TO'}
        />
      )}
      {infoPreview && isOpenNotes && (
        <ModalNotes isOpen={isOpenNotes} onClose={onCloseNotes} idPolicy={String(parseId(infoPreview.id))} />
      )}
      {infoPreview && isOpenLogs && (
        <ModalViewLogs isOpen={isOpenLogs} onClose={onCloseLogs} id={infoPreview.id} />
      )}
      {infoPreview && isOpenDuplicate && (
        <ModalDuplicatePolicy
          id={infoPreview.id}
          isOpen={isOpenDuplicate}
          onClose={onCloseDuplicate}
          refetch={refetch}
        />
      )}
      {isOpenReassignPolicies && (
        <ModalReassignPolicies
          isOpen={isOpenReassignPolicies}
          onClose={onCloseReassignPolicies}
          updateListPolicies={refetch}
          filters={formData}
          tabFilters={tabFilters}
          selectedYears={selectedYears}
          searchByMembers={searchByMembers}
          filtersConfig={filtersConfig}
          dateRangeFilters={dateRangeFilters}
          formatDate={formatDate}
        />
      )}
      {isOpenUpdatePolicies && (
        <ModalUpdatePolicies
          isOpen={isOpenUpdatePolicies}
          onClose={onCloseUpdatePolicies}
          updateListPolicies={refetch}
          filters={formData}
          tabFilters={tabFilters}
          selectedYears={selectedYears}
          searchByMembers={searchByMembers}
          totalItems={totalItems}
          policyStatuses={filterData.policyStatuses}
          filtersConfig={filtersConfig}
          dateRangeFilters={dateRangeFilters}
          formatDate={formatDate}
          selectedPolicies={policiesSelected || []}
        />
      )}
      {selectedBatchId && (
        <ModalViewCarrierImportBatch
          show={isOpenViewBatch}
          onClose={onCloseViewBatch}
          batchId={selectedBatchId}
          policyStatuses={filterData.policyStatuses || []}
        />
      )}
      {selectedCarrierStatusPolicyId && (
        <ModalCarrierStatusDetails
          show={isOpenCarrierStatus}
          onClose={onCloseCarrierStatus}
          policyId={selectedCarrierStatusPolicyId}
        />
      )}
      <Modal show={showConfirmPaid} onHide={() => setShowConfirmPaid(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Mark policies as paid</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to mark {policiesSelected?.length || 0} polic
          {policiesSelected?.length === 1 ? 'y' : 'ies'} as paid to the advisor?
          <div className='mt-3'>
            <Form.Label>Paid date</Form.Label>
            <Form.Control
              type='date'
              value={paidAt}
              onChange={(e) => setPaidAt(e.target.value)}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => setShowConfirmPaid(false)}>
            Cancel
          </Button>
          <Button
            variant='success'
            onClick={() => {
              setShowConfirmPaid(false)
              handleMarkPoliciesPaid(paidAt)
            }}
            disabled={loadingMarkPoliciesPaid}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Unpaid to Advisor */}
      <Modal show={showConfirmUnpaid} onHide={() => setShowConfirmUnpaid(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Unpaid to Advisor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to mark {policiesSelected?.length || 0} polic{policiesSelected?.length === 1 ? 'y' : 'ies'} as unpaid to advisor?</p>
          <p className='text-muted' style={{ fontSize: '0.9rem' }}>
            This action will unmark {policiesSelected?.length === 1 ? 'this policy' : 'these policies'} as paid to the advisor and remove the payment date from the records.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => setShowConfirmUnpaid(false)}>
            Cancel
          </Button>
          <Button
            variant='warning'
            onClick={() => {
              setShowConfirmUnpaid(false)
              handleUnpaidToAdvisor()
            }}
            disabled={loadingUnpaid}
          >
            Confirm Unpaid
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Chargeback to Advisor */}
      <Modal show={showConfirmChargeback} onHide={() => setShowConfirmChargeback(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Chargeback to Advisor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Mark {policiesSelected?.length || 0} polic{policiesSelected?.length === 1 ? 'y' : 'ies'} as chargeback to advisor.</p>
          <div className='mt-3'>
            <Form.Label>Chargeback date</Form.Label>
            <Form.Control
              type='date'
              value={chargebackAt}
              onChange={(e) => setChargebackAt(e.target.value)}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => setShowConfirmChargeback(false)}>
            Cancel
          </Button>
          <Button
            variant='danger'
            onClick={() => {
              setShowConfirmChargeback(false)
              handleChargebackToAdvisor(chargebackAt)
            }}
            disabled={loadingChargeback}
          >
            Confirm Chargeback
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Remove Chargeback */}
      <Modal show={showConfirmUnchargeback} onHide={() => setShowConfirmUnchargeback(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Remove Chargeback</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to remove chargeback from {policiesSelected?.length || 0} polic{policiesSelected?.length === 1 ? 'y' : 'ies'}?</p>
          <p className='text-muted' style={{ fontSize: '0.9rem' }}>
            This action will unmark {policiesSelected?.length === 1 ? 'this policy' : 'these policies'} as chargeback and remove the chargeback date from the records.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => setShowConfirmUnchargeback(false)}>
            Cancel
          </Button>
          <Button
            variant='danger'
            onClick={() => {
              setShowConfirmUnchargeback(false)
              handleUnchargebackToAdvisor()
            }}
            disabled={loadingUnchargeback}
          >
            Confirm Remove Chargeback
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal de Exportación */}
      <Modal show={isOpenExportModal} onHide={onCloseExportModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Export Options</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className='mb-3'>
              <Form.Check
                type='checkbox'
                id='checkPreviousYear'
                label='Search for policies from the previous year'
                checked={exportOptions.checkPreviousYear}
                onChange={(e) =>
                  setExportOptions({ ...exportOptions, checkPreviousYear: e.target.checked })
                }
              />
              <Form.Text className='text-muted'>
                If a policy has an effective date in {moment().year() + 1}, it will search for a
                matching policy in {moment().year()}
              </Form.Text>
            </Form.Group>
            <Form.Group className='mb-3'>
              <Form.Check
                type='checkbox'
                id='checkNextYear'
                label='Search for policies from the next year (renewal)'
                checked={exportOptions.checkNextYear}
                onChange={(e) =>
                  setExportOptions({ ...exportOptions, checkNextYear: e.target.checked })
                }
              />
              <Form.Text className='text-muted'>
                If a policy has an effective date in {moment().year()}, it will search for a
                matching policy in {moment().year() + 1}
              </Form.Text>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={onCloseExportModal}>
            Cancel
          </Button>
          <Button variant='primary' onClick={handleDownload} disabled={loadingExports}>
            {loadingExports ? (
              <>
                <Spinner animation='border' size='sm' /> Exporting...
              </>
            ) : (
              <>
                <i className='bi bi-download'></i> Export
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>
      {hsSelectedMember && (
        <ModalHealthSherpaSearch
          isOpen={hsSearchModalOpen}
          onClose={() => setHsSearchModalOpen(false)}
          member={hsSelectedMember}
          searchResults={hsSearchResults}
          agentEmail={hsAgentEmail}
          onSuccess={() => {
            // Refetch to update status
            refetch()
          }}
        />
      )}
    </div>
  )
}
